import config from '@/config'
import router from '@/router'
import { store } from '@/store/store'
import axios from 'axios'
import moment from 'moment'
import Vue from 'vue'

axios.defaults.timeout = 30000
export default {
  authDefault: function (creds, callback) {
    let url = 'adminlogin'
    if (creds.userid == 'zwizadmin') {
      url += `?limit=100&offset=${creds.offset}`
      if (creds.pagename) url += `&pagename=${creds.pagename}`
    }
    axios
      .post(config.serverUrl + url, {
        userid: creds.userid,
        password: creds.password,
        'g-recaptcha-response': creds['g-recaptcha-response']
      })
      .then((response) => {
        response = response.data
        if (response.responsecode === 200) {
          callback(null, response)
        } else if (response.responsecode === 400) {
          let message = response.reason ? response.reason : 'Something went wrong, please try again'
          store
            .dispatch('logout', {
              error: { code: response.responsecode, message: message }
            })
            .then(function () {
              router.push('/' + store.getters.currentLang + '/nigol')
            })

          // router.push('/nigol')
          callback(new Error(message))
        } else {
          if (response.reason) {
            callback(new Error(response.reason))
          }
        }
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getLongLiveToken: function (creds, callback) {
    axios
      .post(config.serverUrl + 'getlonglivetoken', {
        appid: config.appid,
        accesstoken: creds.accessToken
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getPageList: function (data, callback) {
    axios
      .get(
        'https://graph.facebook.com/v3.1/me/accounts?access_token=' +
          data.token +
          '&limit=1000&fields=access_token,category,category_list,id,tasks,name,name_with_location_descriptor'
      )
      .then((response) => {
        // JSON responses are automatically parsed.
        response = response.data
        if (response.data) {
          let pagelist = []
          response.data.forEach((value) => {
            var page = Object.assign({}, value)
            page.name = page.name_with_location_descriptor
            if (page) {
              pagelist.push(page)
            }
          })
          callback(null, pagelist)
        } else {
          callback(new Error(response.reason))
        }
      })
      .catch((e) => {
        console.error(e)
        callback(new Error('session expire. Please login again.'))
      })
  },
  getPostData: function (data, callback) {
    axios
      .get(
        `https://graph.facebook.com/${data.postid}?access_token=` +
          store.state.selectedBot.page_access_token
      )
      .then((response) => {
        // JSON responses are automatically parsed.
        // var response = response.data
        if (response) {
          callback(null, response)
        } else {
          callback(new Error(response.reason))
        }
      })
      .catch((e) => {
        console.error(e)
        callback(new Error('session expire. Please login again.'))
      })
  },

  getBotList: function (data, token, callback) {
    axios.defaults.headers.common = {
      authorization: token
    }
    axios
      .post(config.serverUrl + 'checkbotlist', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getAllPublicTheme: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'getallpublictheme?appid=' + data.appid)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getProducts: function (data, callback) {
    let url = config.serverUrl + 'products'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getProductsKFC: function (data, callback) {
    let url = config.serverUrl + 'kfc/cms/products'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getAllApplicants: function (data, callback) {
    let url = config.serverUrl + 'scgcareer/applicant/all'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getWorkStyleResult: function (data, callback) {
    let url = config.serverUrl + 'scgcareersadventureresult'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getHafeleUsername(data, callback) {
    let url = config.serverUrl + 'gethafeleusername'
    if (data['filter']) {
      url += '?' + this.joinFilter(data['filter'], store.getters.getPackage == 'premium')
      delete data['filter']
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getLinePushMessageCount: function (data, callback) {
    let url = config.serverUrl + 'getuulinepushmessagcount'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getOpentasks: function (data, callback) {
    let url = config.serverUrl + 'opentasks'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getAdminstatus: function (data, callback) {
    let url = config.serverUrl + 'adminstatus'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getSignedRequestV1: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    let url = config.serverUrl + 'sign-s3?file-name=' + data.name + '&file-type=' + data.type
    url = url.replace(/#/gim, '')

    axios
      .get(url)
      .then((response) => {
        // JSON responses are automatically parsed.
        response = response.data
        response.file = data.file
        this.uploadfileV1(response, function () {
          callback(null, response.url)
        })
      })
      .catch((e) => {
        console.error(e)
        callback(new Error('session expire. Please login again.'))
      })
  },

  uploadfileV1: function (data, callback) {
    let signedRequest = data.signedRequest
    let request = data.file
    const xhr = new XMLHttpRequest()
    xhr.open('PUT', signedRequest)
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          callback()
        } else {
          alert('Could not upload file.')
        }
      }
    }
    xhr.send(request)
  },

  // -------------   V2    ----------------
  uploadfile: function (data, callback) {
    let signedRequest = data.signedRequest
    const formData = new FormData()
    formData.append('acl', 'public-read')
    Object.keys(signedRequest.fields).forEach((key) => {
      formData.append(key, signedRequest.fields[key])
    })

    // Actual file has to be appended last.
    formData.append('file', data.file)
    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + ', ' + pair[1]);
    // }

    const xhr = new XMLHttpRequest()
    xhr.open('POST', signedRequest.url, true)
    xhr.send(formData)
    xhr.onload = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200 || xhr.status === 204) {
          callback()
        } else {
          alert('Could not upload file.')
        }
      }
    }
  },

  getKasikornCareerUserCareerResult: function (data, callback) {
    let url = config.serverUrl + 'kasikorncareerusercareerresult'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getKasikornCareerResult2: function (data, callback) {
    let url = config.serverUrl + 'kasikorncareerresult2'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getKasikornCareerResult3: function (data, callback) {
    let url = config.serverUrl + 'kasikorncareerresult3'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getCategories: function (data, callback) {
    let url = config.serverUrl + 'categories'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getCategoriesKFC: function (data, callback) {
    let url = config.serverUrl + 'kfc/cms/categories'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getSubCategoriesKFC: function (data, callback) {
    let url = config.serverUrl + 'kfc/cms/subcategories'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveProduct: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'products', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  editProduct: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'products?id=' + data.id, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  editProductKFC: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'kfc/cms/products', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  sycnKFCProduct: function (pageid, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'kfc/cms/sync-products', { pageid })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getUsersdata: function (data, callback) {
    let url = config.serverUrl + 'usersdata'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  changepasswordadminuser(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'changepasswordadminuser', { password: data.password })

      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveSahapanUserProfile: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'sahapanuserprofile?lineid=' + data.lineid, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getAstonAdminUserDetails: function (data, callback) {
    let url = config.serverUrl + 'astonadminuserdetails'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getSahapanCountUsersByAge: function (data, callback) {
    let url = config.serverUrl + 'sahapancountusersbyage'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getsahapanredeemdetailall: function (data, callback) {
    let url = config.serverUrl + 'sahapanredeemdetailall'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getSahapanCountUsersByProvince: function (data, callback) {
    let url = config.serverUrl + 'sahapancountusersbyprovince'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getnvbbquotahistory: function (data, callback) {
    let url = config.serverUrl + 'nvbbquotahistory'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  saveUserAddress: function (data, callback) {
    let params = data.start ? { dateFrom: data.start, dateTo: data.end } : {}
    Object.assign(params, { pageid: data.pageid })
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'useraddress?pageid=' + data.pageid, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveUuID: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'uuid?pageid=' + data.pageid, data)

      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveUuRealName: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'uurealname?pageid=' + data.pageid, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveUuAreaname: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'uuareaname?pageid=' + data.pageid, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveUuDma: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'uudma?pageid=' + data.pageid, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveUuLocation: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'uulocation?pageid=' + data.pageid, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getLeologisticsUsername: function (data, callback) {
    let url = config.serverUrl + 'getleologisticsusername'
    // multistatusordersummary?pageid=....&orderidlist=.....&statusorder=......
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteLeologisticsUsername: function (data, callback) {
    let url = config.serverUrl + 'removeleologisticsusername'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  // putastonqacustomerservice: function(data, callback) {

  saveLeologisticsUsername: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'createleologisticsusername', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getQeUsersGroup: async function (data) {
    let url = config.serverUrl + 'qeusersgroup'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      const response = await axios.get(url, { params: data })
      return this.defaultResponse(response, null)
    } catch (error) {
      return this.defaultError(error, null)
    }
  },

  getHafeleRedeemDetailByEmpid: function (data, callback) {
    let url = config.serverUrl + 'gethafeleredeemdetailbyempid'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getHafeleRedeemDetail: function (data, callback) {
    let url = config.serverUrl + 'gethafeleredeemdetail'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveHafeleUsername: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'createhafeleusername', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveHafeleRedeemDetail: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(`${config.serverUrl}updatehafeleredeemdetail?id=${data['id']}`, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  uploadHafeleUsername: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'uploadhafeleusername', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  updateHafeleUsername: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(`${config.serverUrl}updatehafeleusername?emp_id=${data['emp_id']}`, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteHafeleUsername: function (data, callback) {
    let url = config.serverUrl + 'removehafeleusername'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  generaliinsertholiday: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'generaliholiday?pageid=' + data['pageid'], data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getAllgeneraliholidays: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'generaliholiday?pageid=' + data['pageid'])
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  updategeneraliholiday: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(
        config.serverUrl + 'generaliholiday?pageid=' + data['pageid'] + '&id=' + data['id'],
        data
      )
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deletegeneraliholiday: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'generaliholiday?pageid=' + data['pageid'] + '&id=' + data['id'])
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  gettagreportgenerali: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(
        config.serverUrl +
          `tagreportgenerali?pageid=${data.pageid}&startDate=${data.start}&endDate=${data.end}${
            data.filter != 'all' ? `&app=${data.filter}` : ''
          }`
      )
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getanandaregisterliffurl(callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `anandaregisterliffurl`)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postanandaregisterliffurl(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + `anandaregisterliffurl`, data.input)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putanandaregisterliffurl(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `anandaregisterliffurl?id=${data.id}`, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleteanandaregisterliffurl(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + `anandaregisterliffurl?id=${data.id}`)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getuseranandaregister(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `useranandaregister?id=${data.id}`)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getDplusPromotion: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `dpluspopup`
    axios
      .get(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  updateDplusPromotion: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `dpluspopup`, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  postrunbetterdonationproject: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `runbetterdonationproject`
    axios
      .post(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putrunbetterdonationproject: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `runbetterdonationproject`
    axios
      .put(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getFacebookPayStatus: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `checkfbpaystatus`
    axios
      .get(config.serverUrl + url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getrunbetterdonationproject: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `runbetterdonationproject`
    axios
      .get(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleterunbetterdonationproject: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `runbetterdonationproject`
    axios
      .delete(config.serverUrl + url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getscgallrentcustomers(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `scgallrentcustomers`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getscgallrenthistory(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `scgallrenthistory?id=` + data.id
    axios
      .get(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  putscgallrentchangestatus: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `scgallrentchangestatus`
    axios
      .put(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  scgallrentupdateremark: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `scgallrentupdateremark?id=${data.id}&remark=${data.remark}`
    axios
      .put(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putupdateTrainingConversation: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'updatedefaultchatlogs', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  postpttlnguserprofile: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `pttlnguserprofile`
    axios
      .post(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putpttlnguserprofile: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `pttlnguserprofile?emp_id=${data['emp_id']}`
    axios
      .put(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getpttlngalluserprofile(callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `pttlngalluserprofile`
    axios
      .get(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deletepttlngalluserprofile(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `pttlnguserprofile?emp_id=${data.emp_id}`
    axios
      .delete(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postpttlngictdevices: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `pttlngictdevices`
    axios
      .post(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putpttlngictdevices: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `pttlngictdevices?id=${data['id']}`
    axios
      .put(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getpttlngictdevicesbyempid(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `pttlngictdevicesbyempid?emp_id=` + data.emp_id
    axios
      .get(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putcollectexportcustomersanalytic(data, callback) {
    let url = config.serverUrl + 'collectexportcustomersanalytic'

    var body = {
      ...data,
      ...this.joinFilterToObject(data['filter'], store.getters.getPackage == 'premium')
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, body)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deletepttlngictdevices(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `pttlngictdevices?id=${data.id}`
    axios
      .delete(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putscgallrentsuppliersById: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `scgallrentsuppliersById?id=${data['id']}`
    axios
      .put(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getscgallrentsuppliers(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `scgallrentsuppliers`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getsahapanrewardcategories(callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `sahapanrewardcategories`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deletesahapanrewardcategories(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
    let url = `sahapanrewardcategories?id=${data.id}&pageid=${data.pageid}`
      .delete(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postsahapanrewardcategories: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `sahapanrewardcategories`
    axios
      .post(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  putsahapanrewardcategories: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `sahapanrewardcategories?pageid=${data.pageid}&id=${data.id}`
    axios
      .put(config.serverUrl + url, { name: data.name })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getsahapanrewardproducts(callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `sahapanrewardproducts`
    axios
      .get(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deletesahapanrewardproducts(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `sahapanrewardproducts?id=${data.id}&pageid=${data.pageid}`
    axios
      .delete(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  postsahapanrewardproducts: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `sahapanrewardproducts`
    axios
      .post(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  putsahapanrewardproducts: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `sahapanrewardproducts?pageid=${data.pageid}&id=${data.id}`
    axios
      .put(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getsahapantoplocations(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `sahapantoplocations`
    axios
      .get(config.serverUrl + url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getsahapantoprewardpoint(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `sahapantoprewardpoint`
    axios
      .get(config.serverUrl + url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getsalesreport(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `salesreport`
    axios
      .get(config.serverUrl + url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getsahapanpointdetailall(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `sahapanpointdetailall`
    axios
      .get(config.serverUrl + url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putsahapanupdatepoint: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `sahapanupdatepoint`
    axios
      .put(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  putsahapanupdatepointmanual: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `sahapanupdatepointmanual`
    axios
      .put(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  sahapanprioritycategories: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `sahapanprioritycategories?pageid=${data.pageid}`, {
        categorieslist: data.input
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getallrenttransactionlivechat: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `allrenttransactionlivechat`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  putusersessionvalue(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'usersessionvalue?pageid=' + data.pageid, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  editProductStatus: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productsstatus?id=' + data.id, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteProduct: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'products?id=' + data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getSignedRequest: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    let url = config.serverUrl + 'sign-s3-v2?file-name=' + data.name + '&file-type=' + data.type
    url = url.replace(/#/gim, '')

    axios
      .get(url)
      .then((response) => {
        // JSON responses are automatically parsed.
        var response = response.data
        response.file = data.file
        this.uploadfile(response, function () {
          callback(null, response.url)
        })
      })
      .catch((e) => {
        callback(new Error('session expire. Please login again.'))
      })
  },

  // uploadfile: function (data, callback) {
  //   let signedRequest = data.signedRequest
  //   let request = data.file
  //   const xhr = new XMLHttpRequest()
  //   xhr.open('PUT', signedRequest)
  //   xhr.onreadystatechange = () => {
  //     if (xhr.readyState === 4) {
  //       if (xhr.status === 200) {
  //         callback()
  //       } else {
  //         alert('Could not upload file.')
  //       }
  //     }
  //   }
  //   xhr.send(request)
  // },

  // -------------   V2    ----------------
  uploadfile: function (data, callback) {
    let signedRequest = data.signedRequest
    const formData = new FormData()
    formData.append('acl', 'public-read')
    Object.keys(signedRequest.fields).forEach((key) => {
      formData.append(key, signedRequest.fields[key])
    })

    // Actual file has to be appended last.
    formData.append('file', data.file)
    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + ', ' + pair[1]);
    // }

    const xhr = new XMLHttpRequest()
    xhr.upload.addEventListener(
      'progress',
      (event) => {
        var percent = (event.loaded / event.total) * 100
        store.state.progress = percent
      },
      false
    )
    xhr.open('POST', signedRequest.url, true)
    xhr.send(formData)
    xhr.onload = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200 || xhr.status === 204) {
          callback()
        } else {
          alert('Could not upload file.')
        }
      }
    }
  },

  saveSubCategory: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'subcategories', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  editSubCategory: function (data, callback) {
    let request = {
      name: data.name
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'subcategories?id=' + data.id, request)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveProductStock: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'productstock?productid=' + data.productid, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  unSubscribe: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'unsubscribe', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getAllUsers: function (data, callback) {
    let url = config.serverUrl + 'getallusers'
    var body = {
      ...data,
      ...this.joinFilterToObject(data['filter'], store.getters.getPackage == 'premium')
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, body)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  multicast: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'multicast', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  toggleBotStatus: function (data, callback) {
    let url = !data.status ? 'stopbot' : 'startbot'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  checkBotlist: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'checkbotlist', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveWelcomeMessage: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'botwelcomemessage', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getWelcomeMessage: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'botwelcomemessage?pageid=' + data['pageid'])
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getLiveChatUsers: async function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      const resData = await axios.post(config.serverUrl + 'getuserthread', data.body, {
        params: data.params
      })
      this.defaultResponse(resData, callback, false)
    } catch (error) {
      this.defaultError(error, callback)
    }
  },
  async sendMessage(data) {
    try {
      const response = await axios.post(`${config.serverUrl}sendmessage`, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, {
        isForceLogout: false
      })
    } catch (error) {
      return await this.defaultError2(error)
    }
  },

  endSessionChat: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'endconversation', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  openSessionChat: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'startconversation', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getIntent: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    let url = `${config.serverUrl}intents`

    axios
      .get(url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  insertUsersFromDone: function (data, callback) {
    let url = config.serverUrl + 'insertusersfromdone?pageid=' + data.pageid
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  addIntent: async function (data, callback, manualHandle = false) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    const response = await axios
      .post(config.serverUrl + 'intents', data)
      .then((response) => {
        if (manualHandle) {
          return response
        } else {
          this.defaultResponse(response, callback)
        }
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
    if (manualHandle) {
      return response
    }
  },

  editIntent: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'intents?id=' + data['id'], data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteIntent: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'intents', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getDashboardIntent: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    const url = `${config.serverUrl}pagereport_intents`
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getDashboardActiveUserByDate: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    const url = `${config.serverUrl}pagereport_activeusers_bydate`

    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getDashboardActiveUserByTime: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    const url = `${config.serverUrl}pagereport_activeusers_bytime`
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getdashbroadshopanalytic(data, callback) {
    const url = `${config.serverUrl}salesreport`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  editOrderSummary: function (data, callback) {
    var url = config.serverUrl + 'ordersummary?'
    if (data.lineid && data.lineid != '' && data.lineid != null) {
      url += 'lineid=' + data['lineid'] + '&pageid=' + data['pageid']
    } else if (data.pageid && data.pageid != '' && data.pageid != null) {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      url += 'pageid=' + data['pageid']
    }
    url += '&id=' + data.id
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveOrdersTracking(data, callback) {
    var url = config.serverUrl + 'ordertracking'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getShopProfile: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'shopprofile?pageid=' + data['pageid'])
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  editShopProfile: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'shopprofile?pageid=' + data.pageid, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getLineNotifySubscriber: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'notifyadminuser?pageid=' + data['pageid'])
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteLineNotifySubscriber: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(
        config.serverUrl +
          'notifyadminuser_remove?pageid=' +
          data['pageid'] +
          '&userid=' +
          data['userid'],
        data
      )
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getChatUsersLine: function (data, callback) {
    // axios.defaults.headers.common = {
    // 	'AUTHORIZATION': store.getters.securityToken
    // };
    axios
      .get(
        config.serverUrl +
          'getuserthread?pageid=' +
          data['pageid'] +
          '&app=' +
          data['app'] +
          '&inbox=' +
          data['type'] +
          '&limit=' +
          data['limit'] +
          '&offset=' +
          data['offset']
      )
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getPaypalTrackingStatus: function (data, callback) {
    axios
      .get(config.serverUrl + 'getpaypal_trackingstatus?tracking_id=' + data['tracking_id'])
      .then((response) => {
        // this.defaultResponse(response, callback)
        callback(null, response.data)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  updatePaypalMerchantId: function (data, callback) {
    // paypal_merchantid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'updatepaypal_merchantid?pageid=' + data['pageid'], data)
      .then((response) => {
        callback(null, response.data)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getSetting: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'getallcontent?pageid=' + data['pageid'])
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getBotDetail: function (data, callback) {
    // console.log(store.getters.securityToken)
    if (!data['pageid']) {
      return false
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'checkbotpage?pageid=' + data['pageid'])
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getPersistentMenu: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'getmessenger_profile', {
        pageid: data['pageid'],
        status: data['status'],
        fields: 'persistent_menu',
        access_token: data['access_token']
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  editPersistentMenu: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url = config.serverUrl + 'messenger_profile'
    // delete data.pageid
    // delete data.status
    // delete data.access_token
    axios
      .post(url, { ...data, fields: 'persistent_menu' })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  updateTrainingConversation: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'updatedefaultchatlogs', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  updateConfig: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'updateadminconfig', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getBroadcast: function (data, callback) {
    let url = `${config.serverUrl}getbroadcast`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  estimateReach: function (data, callback) {
    // if (data.filter.messagesent.value) {
    //   data.filter.messagesent = (data.filter.messagesent.symbol.value + data.filter.messagesent.value)
    // }
    let url = config.serverUrl + 'estimatereach'
    if (data['filter'] && store.getters.getPackage == 'premium') {
      var body = {
        ...data,
        ...this.joinFilterToObject(data['filter'], store.getters.getPackage == 'premium')
      }
    } else {
      var body = data
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, body)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  collectexportcustomersanalytic(data, callback) {
    let url = config.serverUrl + 'collectexportcustomersanalytic?pageid=' + data.pageid
    if (data['filter'] && store.getters.getPackage == 'premium') {
      url += '&' + this.joinFilter(data['filter'], true)
    } else if (data['condition']) {
      url += data['condition']
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  updateBroadcast: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    if (data['filter']) {
      var filter = ''
      filter += this.joinFilter(data['filter'], true)
      data.m_condition = filter
    }
    axios
      .post(`${config.serverUrl}savebroadcast`, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  editProductBundle: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productbundle?productbundleid=' + data.id, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteProductBundle: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'productbundle?productbundleid=' + data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveCategory: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'categories', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveSubCategory: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'categories', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  editCategory: function (data, callback) {
    let request = {
      name: data.name,
      display_name: data.display_name
    }
    if (data && data.hasOwnProperty('is_hidden')) {
      Object.assign(request, { is_hidden: data.is_hidden })
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'categories?id=' + data.id, request)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  editCategoryKFC: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'kfc/cms/categories', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  kfcEditSubCategory: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'kfc/cms/subcategories', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteCategory: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'categories?id=' + data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteSubCategory: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'subcategories?id=' + data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getProductStock: function (productid, callback) {
    let url = config.serverUrl + 'productstock?productid=' + productid

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  editProductStock: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productstock?productstockid=' + data.id, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteProductStock: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'productstock?productstockid=' + data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  newSubscribe: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'newsubscribe', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  async getUserMessages(data) {
    try {
      const response = await axios.get(config.serverUrl + 'getchatlog', {
        params: data,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  getDashboardSummary: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    const url = `${config.serverUrl}pagereport_summary`
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getOrderSummary: function (data, callback) {
    var url = config.serverUrl + `ordersummary`
    var headers = {}
    if (data.pageid && data.pageid != '' && data.pageid != null) {
      // url += 'pageid=' + data['pageid']
      headers = {
        AUTHORIZATION: store.getters.securityToken
      }
    } else if (data.lineid && data.lineid != '' && data.lineid != null) {
      // url += 'lineid=' + data['lineid']
    }
    // url +=
    // '&datefrom=' + data['datefrom'] + '&dateto=' + data['dateto'] + '&status=' + data['status']

    axios
      .get(url, { params: data, headers: headers })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getTraningConversation: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    // axios.defaults.timeout = 60000;
    axios
      .get(config.serverUrl + 'defaultchatlogs', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteBroadcast: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'deletebroadcast', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getTutoriallist: function (callback) {
    let url = config.serverUrl + 'tutoriallist'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  updateTutoriallist: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'tutoriallist', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getProductBundle: function (data, callback) {
    let url = config.serverUrl + 'productbundle?productid=' + data.id
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveProductBundle: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'productbundle?productid=' + data.productid, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getGbprime: function (data, callback) {
    let url = config.serverUrl + 'gbprime?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveGbprime: function (data, callback) {
    let url = config.serverUrl + 'gbprime?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getLineToken: function (data, callback) {
    let url = config.serverUrl + 'linetoken?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveLineToken: function (data, callback) {
    let url = config.serverUrl + 'linetoken?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  checkGBprimeToken: function (data) {
    return new Promise((resolve, reject) => {
      var request = {
        token: data.token,
        amount: '1',
        referenceNo: new Date().getTime(),
        payType: 'F',
        cardUse: 'Y',
        billUse: 'Y',
        qrUse: 'Y',
        expire: '1',
        deliveryMethod: '0',
        multipleUse: 'N',
        detail: 'Check Valid Token'
      }
      axios
        .post('https://api.gbprimepay.com/gbp/gateway/link', request)
        .then((response) => {
          if (response.data.gbLinkUrl !== undefined) {
            resolve()
          } else {
            reject(new Error('Something wrong'))
          }
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  getPublishedPost: function (fburl, pageid = store.state.selectedBot.pageid) {
    return new Promise((resolve, reject) => {
      let url = null
      if (fburl && fburl != '') {
        url = fburl
      } else {
        url =
          'https://graph.facebook.com/v3.2/' +
          pageid +
          '/posts?access_token=' +
          store.state.selectedBot.page_access_token
      }
      axios
        .get(url)
        .then((response) => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  getSchedulePost: function (fburl) {
    return new Promise((resolve, reject) => {
      let url = null
      if (fburl && fburl != '') {
        url = fburl
      } else {
        url =
          'https://graph.facebook.com/v3.2/' +
          store.state.selectedBot.pageid +
          '/scheduled_posts?access_token=' +
          store.state.selectedBot.page_access_token
      }
      axios
        .get(url)
        .then((response) => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  saveUserStatus: function (data, callback) {
    let url = config.serverUrl + 'userstatus?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getUserStatus: function (data, callback) {
    let url = config.serverUrl + 'userstatus?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveUserEmail: function (data, callback) {
    let url = config.serverUrl + 'useremail?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveUserPhoneno: function (data, callback) {
    let url = config.serverUrl + 'userphoneno?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveUserTags: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'usertags?pageid=' + data.pageid, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveUserProvince: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'userprovince?pageid=' + data.pageid, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveUserLineId: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'userlineid?pageid=' + data.pageid, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveUserSchool: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'userschool?pageid=' + data.pageid, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getWholesaleStatus: function (data, callback) {
    let url = config.serverUrl + 'wholesale_status?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveWholesaleStatus: function (data, callback) {
    let url = config.serverUrl + 'wholesale_status?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getWholesale: function (data, callback) {
    let url = config.serverUrl + 'wholesale?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveWholesale: function (data, callback) {
    let url = config.serverUrl + 'wholesale?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  editWholesale: function (data, callback) {
    let url = config.serverUrl + 'wholesale?wholesaleid=' + data.wholesaleid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteWholesale: function (data, callback) {
    let url = config.serverUrl + 'wholesale?wholesaleid=' + data.wholesaleid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getPauseStatus: function (data, callback) {
    let url = config.serverUrl + 'notreplyduplicateintent?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  togglePauseStatus: function (data, callback) {
    let url = config.serverUrl + 'notreplyduplicateintent?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getReplyDelay: function (data) {
    let url = config.serverUrl + 'replydelay?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    return axios.get(url)
  },

  editReplyDelay: function (data) {
    let url = config.serverUrl + 'replydelay?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    return axios.put(url, data)
  },

  getLineNotify: function (data, callback) {
    let url = config.serverUrl + 'linenotify?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveLineNotify: function (data, callback) {
    let url = config.serverUrl + 'linenotify'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteLineNotify: function (data, callback) {
    let url =
      config.serverUrl + 'linenotify?pageid=' + data['pageid'] + '&adminid=' + data['adminid']
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveLineNotifyNotification: function (data, callback) {
    let url = config.serverUrl + 'notifications?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getCompareIntents: function (data, callback) {
    let url =
      config.serverUrl + 'compareintents?pageid1=' + data.pageid1 + '&pageid2=' + data.pageid2
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getSupportUser: function (data, callback) {
    let url = config.serverUrl + 'supportusers?supportusers=' + data.supportusers
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  transferIntents: function (data, callback) {
    let url = config.serverUrl + 'cloneintents?pageid1=' + data.pageid1 + '&pageid2=' + data.pageid2

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveSupportusers: function (data, callback) {
    let url = config.serverUrl + 'supportusers?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getAllShipingCharge: function (data, callback) {
    let url = config.serverUrl + 'allshipingcharge?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveAllShipingCharge: function (data, callback) {
    let url = config.serverUrl + 'allshipingcharge?pageid=' + data.pageid
    delete data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  insertUsersFromInbox: function (data, callback) {
    let url = config.serverUrl + 'insertusersfrominbox?pageid=' + data.pageid

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getTimeToUseBot: function (data, callback) {
    let url = config.serverUrl + 'timetousebot?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveTimeToUseBot: function (data, callback) {
    let url = config.serverUrl + 'timetousebot?pageid=' + data.pageid
    delete data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getVideoList: function () {
    return new Promise((resolve, reject) => {
      let url =
        'https://graph.facebook.com/v4.0/' +
        store.state.selectedBot.pageid +
        '/video_lists?access_token=' +
        store.state.selectedBot.page_access_token
      axios
        .get(url)
        .then((response) => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  getVideo: function (url) {
    return new Promise((resolve, reject) => {
      if (!url) {
        url =
          'https://graph.facebook.com/v4.0/' +
          store.state.selectedBot.pageid +
          '/videos?access_token=' +
          store.state.selectedBot.page_access_token +
          '&fields=permalink_url,title,description,source,id,picture,length'
      }

      axios
        .get(url)
        .then((response) => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  getWordAfterOrderAndCartSummary: function (data, callback) {
    let url = config.serverUrl + 'wordsafterordersandcartsummary?pageid=' + data.pageid

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios

      .get(url)

      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveWordAfterOrderAndCartSummary: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'wordsafterordersandcartsummary?pageid=' + data.pageid, data)

      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getAstonAdminTasks: function (data, callback) {
    let url = config.serverUrl + 'astonadmintasks'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getAstonAdminTasksOutsource: function (data, callback) {
    let url = config.serverUrl + 'astonadmintasksoutsource'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getAstonAdminTasksLine: function (data, callback) {
    let url = config.serverUrl + 'astonadmintasksline'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getAstonTagOrderFromAds: function (data, callback) {
    let url = config.serverUrl + 'astontagorderfromads'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getAstonRefIdOrderDetail: function (data, callback) {
    let url = config.serverUrl + 'astonrefidorderdetail'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getAstonCloseTasksPerAdmin: function (data, callback) {
    let url = config.serverUrl + 'astonclosetasksperadmin'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getAstonCloseTasksPerAdminOutsource: function (data, callback) {
    let url = config.serverUrl + 'astonclosetasksperadminoutsource'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getAstonAdminUserUserGroupByWord: function (data, callback) {
    let url = config.serverUrl + 'astonadminusergroupbyword'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getKetshopToken: function (data, callback) {
    let url = config.serverUrl + 'ketshop_shoptoken'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveKetshopToken: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(`${config.serverUrl}ketshop_shoptoken?pageid=${data.pageid}`, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveAstonUpdateAdminTasks: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'astonupdateadmintasks', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getbudashboardregisterquestion: function (data, callback) {
    let url = config.serverUrl + 'budashboardregisterquestion'
    let params = data.start ? { dateFrom: data.start, dateTo: data.end } : {}
    Object.assign(params, { pageid: data.pageid })
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getbudashboardfaculty: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(
        config.serverUrl +
          `budashboardfaculty?dateFrom=${data.start}&dateTo=${data.end}&pageid=${data.pageid}`
      )
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getbudashboardscholarships: function (data, callback) {
    let url = config.serverUrl + 'budashboardscholarships'
    let params = data.start ? { dateFrom: data.start, dateTo: data.end } : {}
    Object.assign(params, { pageid: data.pageid })

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  activateredeemcode(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(
        config.serverUrl + 'activateredeemcode?pageid=' + data.pageid + '&redeemcode=' + data.redeem
      )
      .then((response) => {
        callback(null, response.data)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putchangebotstate: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'changebotstate?pageid=' + data.pageid, data.input)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getschoollist: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'schoollist')
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  astonaveragespeedofanswer(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'astonaveragespeedofanswer', {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getastonqacustomerservice(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'astonqacustomerservice', {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  putastonqacustomerservice: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'astonqacustomerservice', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getastonqaadminchatlog(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'astonqaadminchatlog', {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  putastonqaadminchatlog: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'astonqaadminchatlog', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putQvalIntents: function (request, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'qvalintents', request.data, { params: request.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  // multistatusordersummary?pageid=....&orderidlist=.....&statusorder=......
  putmultistatusordersummary: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(
        config.serverUrl +
          `multistatusordersummary?pageid=${data.pageid}&orderidlist=${data.orderid}&statusorder=${data.status}`,
        data.input
      )
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putnvbb_multistatusordersummary: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(
        config.serverUrl +
          `nvbb_multistatusordersummary?pageid=${data.pageid}&orderidlist=${data.orderid}&statusorder=${data.status}`,
        data.input
      )
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putprioritycategories: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    const isShopMain = ['powerbuy'].includes(store.state.selectedBot.theme) && data.shop_main_pageid
    const url = `${config.serverUrl}prioritycategories?pageid=${data.pageid}${
      isShopMain ? `&shop_main_pageid=${data.shop_main_pageid}` : ''
    }`

    axios
      .put(url, {
        categorieslist: data.input
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putprioritycategoriesKFC: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `kfc/cms/priority-categories?pageid=${data.pageid}`, {
        categorieslist: data.input
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putprioritysubcategoriesKFC: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `kfc/cms/priority-subcategories?pageid=${data.pageid}`, {
        subcategorieslist: data.input
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putpriorityproducts: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = ''
    if (['powerbuy'].includes(store.state.selectedBot.theme) && data.shop_main_pageid) {
      url = `${config.serverUrl}priorityproducts?pageid=${data.pageid}&shop_main_pageid=${data.shop_main_pageid}`
    } else {
      url = `${config.serverUrl}priorityproducts?pageid=${data.pageid}`
    }
    axios
      .put(url, {
        productslist: data.input
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getcompareshopservice: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `compareshopservice?pageid1=${data.pageid1}&pageid2=${data.pageid2}`)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  transfershopservice: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(
        config.serverUrl + `transfershopservice?pageid1=${data.pageid1}&pageid2=${data.pageid2}`,
        data
      )
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  saveUserContext: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `usercontext?pageid=${data.pageid}`, {
        context: data.context,
        userid: data.usersid
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  saveUserNote: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `usernote?pageid=${data.pageid}`, {
        note: data.temp_msg,
        usersid: data.usersid
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  saveCustomerRealName: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `usercustomrealname?pageid=${data.pageid}`, {
        customrealname: data.customrealname,
        userid: data.usersid
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  zwizadminbotlist: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `zwizadminbotlist?limit=${data.limit}&offset=${data.offset}`
    if (data.pagename) url += `&pagename=${data.pagename}`
    axios
      .get(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  // getuserCustomer: function(data, callback) {
  //   axios.defaults.headers.common = {
  //     AUTHORIZATION: store.getters.securityToken
  //   }
  //   let url = `getuser?pageid=${data.pageid}&userid=${data.userid}`
  //   axios
  //     .get(config.serverUrl + url)
  //     .then(response => {
  //       this.defaultResponse(response, callback)
  //     })
  //     .catch(e => {
  //       this.defaultError(e, callback)
  //     })
  // },
  getInfocustomerspremium: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `infocustomerspremium?pageid=${data['pageid']}&type=${data.type}&package=${data.package}`
    axios
      .get(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postInfocustomerspremium: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `infocustomerspremium?pageid=${data['pageid']}&package=${data.package}`
    axios
      .post(config.serverUrl + url, data.obj)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  collectlineidpremiumextra: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `collectlineidpremiumextra?pageid=${data['pageid']}`
    axios
      .put(config.serverUrl + url, data.obj)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  productstockadd: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productstockadd?productstockid=${data['productstockid']}`
    axios
      .put(config.serverUrl + url, { addquantity: data.quantity })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  productstockdelete: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productstockdelete?productstockid=${data['productstockid']}`
    axios
      .put(config.serverUrl + url, { deletequantity: data.quantity })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  orderstockadd: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `orderstockadd?orderid=${data['orderid']}`
    axios
      .put(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  orderstockdelete: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `orderstockdelete?orderid=${data['orderid']}`
    axios
      .put(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putauctionfbpost: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `auctionfbpost?id=${data['id']}`
    axios
      .put(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postauctionfbpost: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `auctionfbpost`
    axios
      .post(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getauctionfbpost: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `auctionfbpost?pageid=${data['pageid']}`
    axios
      .get(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  checkChatdayToken: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'chatdaytoken', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getadminperformbypageid: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `adminperformbypageid`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getUserOnly: function (data, callback) {
    let url = config.serverUrl + 'getuseronly'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getPartnerProfile: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `partnerprofile`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getPartnerRedeemCode: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `partnerredeemcode`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getPartnerCustomers: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `partnercustomers`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getNeoMoneyDashboard: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `neomoneydashboard`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLatestSupportUsers: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `latestsupportusers`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getproductlive: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productlive`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putproductlive: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productlive', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postproductlive: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'productlive', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postliveinfo: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'liveinfo', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postsendordersummaryall: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'sendordersummaryall', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putchangeproductlivestatus: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'changeproductlivestatus', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postsendordersummarybyuser: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'sendordersummarybyuser', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postproductstocklive: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'productstocklive', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putliveinfo: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'liveinfo', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putproductstocklive: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productstocklive', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putcartsummarypattern: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'cartsummarypattern', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putcartsummarypatternstatus: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'cartsummarypatternstatus', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postuploadcentralproducts: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'uploadcentralproducts', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleteproductlive: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productlive`
    axios
      .delete(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleteproductstocklive: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `productstocklive`
    axios
      .delete(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getliveinfo: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `liveinfo`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getuserCustomerOnly: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `getuseronly?pageid=${data.pageid}&userid=${data.userid}`
    axios
      .get(config.serverUrl + url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getliveinfodetail: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `liveinfodetail`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getchatstat: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `chatstat`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getorderstat: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `orderstat`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  gettoporderslive: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `toporderslive`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getordersummarylive: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `ordersummarylive`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getexportcmsviewcarts: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `exportcmsviewcarts`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleteliveinfo: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `liveinfo`
    axios
      .delete(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getusercartslive: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `usercartslive`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getcartsummarypattern: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `cartsummarypattern`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleteclearcartslive: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `clearcartslive`
    axios
      .delete(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getcmsviewcarts: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `cmsviewcarts`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getcmsviewcartshistory: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `cmsviewcarts_history`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getusercart: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `usercart`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  postUsersmanual: function (data, callback) {
    axios
      .post(config.serverUrl + 'usersmanual', data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putUsersmanual: function (data, callback) {
    axios
      .put(config.serverUrl + 'usersmanual', data.data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getTickets: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `tickets`, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getTicketById: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `ticketsbyid`, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getTicketByAdminId: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `ticketsbyadminid`, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getTicketListByUser: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `ticketsbyuserid`, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  postTickets: function (data, callback) {
    axios
      .post(config.serverUrl + 'tickets', data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  putTickets: function (data, callback) {
    axios
      .put(config.serverUrl + 'tickets', data.data, {
        params: data.params,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  async CloseLastestTicket(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.serverUrl + 'kfc/ticket/', null, {
          params: data,
          headers: {
            AUTHORIZATION: store.getters.securityToken
          }
        })
        .then((response) => {
          resolve(response)
        })
        .catch((e) => {
          resolve({ error: true })
        })
    })
  },

  getAdminGroup: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    if (data.isCentral) {
      var url = 'uploadcentralproducts'
    } else {
      var url = 'uploadzwizproducts'
    }
    axios
      .get(config.serverUrl + `admingroup`, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getordersbyid: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `ordersbyid`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getorders2byid: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `orders2byid`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getAdminSubGroup: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `adminsubgroup`, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveSlip: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    axios
      .put(config.serverUrl + 'ordersummarynote', data.data, {
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getAdmins: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `adminuser`, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getTicketsByAgent: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `ticketsbyagent`, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getTicketsByStatus: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `ticketsbystatus`, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  postadmingroup: function (data, callback) {
    axios
      .post(config.serverUrl + `admingroup`, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  putadmingroup: function (data, callback) {
    axios
      .put(config.serverUrl + `admingroup`, data.data, {
        params: data.params,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteadmingroup: function (data, callback) {
    axios
      .delete(config.serverUrl + `admingroup`, {
        params: data,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  postadminsubgroup: function (data, callback) {
    axios
      .post(config.serverUrl + `adminsubgroup`, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  putadminsubgroup: function (data, callback) {
    axios
      .put(config.serverUrl + `adminsubgroup`, data.data, {
        params: data.params,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteadminsubgroup: function (data, callback) {
    axios
      .delete(config.serverUrl + `adminsubgroup`, {
        params: data,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteAllInCart(data, callback) {
    axios
      .delete(config.serverUrl + 'cmsviewcarts', {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        data: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  createadminuser(data, callback) {
    axios
      .post(config.serverUrl + `createadminuser`, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  createAdminUserManual(data, callback) {
    let url = `${config.serverUrl}createadminusermanual`
    axios
      .post(url, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteadminusers(data, callback) {
    axios
      .delete(config.serverUrl + 'adminusers', {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        data: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  changeprivilegeadminuser(data, callback) {
    axios
      .put(config.serverUrl + `changeprivilegeadminuser`, data.data, {
        params: data.params,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  changeticketpasswordadminuser(data, callback) {
    axios
      .put(config.serverUrl + `changepasswordadminuser`, data.data, {
        params: data.params,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  toadealerupdatetoken(data, callback) {
    axios
      .put(config.serverUrl + `toadealerupdatetoken`, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getastonconversationrateperadmin: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `astonconversationrateperadmin`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getNvbbOrderSummary: function (data, callback) {
    var url = config.serverUrl + `ordersummary2?`
    if (data.pageid && data.pageid != '' && data.pageid != null) {
      url += 'pageid=' + data['pageid']
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
    } else if (data.lineid && data.lineid != '' && data.lineid != null) {
      url += 'lineid=' + data['lineid']
    }
    var shippingtype = ''
    var tab = ''
    var allcontents = null
    if (data['shippingtype']) {
      shippingtype = '&shippingtype=' + data['shippingtype']
    }
    if (data['tab']) {
      tab = '&tab=' + data['tab']
    }
    if (data['allcontents'] !== null) {
      allcontents = '&allcontents=' + data['allcontents']
    }
    url +=
      '&datefrom=' +
      data['datefrom'] +
      '&dateto=' +
      data['dateto'] +
      '&status=' +
      data['status'] +
      shippingtype +
      tab +
      allcontents
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  editNvbbOrderSummary: function (data, callback) {
    var url = config.serverUrl + 'ordersummary2?'
    if (data.lineid && data.lineid != '' && data.lineid != null) {
      url += 'lineid=' + data['lineid'] + '&pageid=' + data['pageid']
    } else if (data.pageid && data.pageid != '' && data.pageid != null) {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      url += 'pageid=' + data['pageid']
    }
    url += '&id=' + data.id
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getgetstartedmenu: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `getstarted_menu`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  savegetstartedmenu: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'getstarted_menu', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveUserAddress: function (data, callback) {
    let url = config.serverUrl + 'useraddress?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  gettoacmspainterdetails(data, callback) {
    let url = config.serverUrl + 'toacmspainterdetails'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  toaupdatestatuspainter(data, callback) {
    let url =
      config.serverUrl + 'toaupdatestatuspainter?pageid=' + data.pageid + '&userid=' + data.userid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  savefbpaystatus(data, callback) {
    let url = config.serverUrl + 'fbpaystatus'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  adminreadchat(data, callback) {
    let url = config.serverUrl + 'adminreadchat'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getpromotioncode: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `promotioncode`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  savepromotioncode(data, callback) {
    let url = config.serverUrl + 'promotioncode'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data.data, {
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  editpromotioncode: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'promotioncode', data.data, {
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deletepromotioncode(data, callback) {
    axios
      .delete(config.serverUrl + 'promotioncode', {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  toarcustomerpersonalinfo(data, callback) {
    let url = config.serverUrl + 'toarcustomerpersonalinfo'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getchatlogthaiunionformat(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `chatlogthaiunionformat`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  toacustomerhistorysearchpainter(data, callback) {
    let url = config.serverUrl + 'toacustomerhistorysearchpainter'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  livechatnotiunread(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    const useNewApi = [
      '102549712095297',
      '126654220708334',
      '111901618984646',
      '200701213291845',
      '346030320266',
      '107189438405112'
    ].includes(data.pageid)
    let url = useNewApi ? `api/users/unread-count` : `livechatnotiunread`

    let params = {
      ...data,
      page_id: data.pageid
    }
    axios
      .get(config.serverUrl + url, {
        params
      })
      .then((response) => {
        let result = response
        if (useNewApi) {
          result = {
            ...result,
            data: {
              data: [response.data.data],
              responsecode: 200
            }
          }
        }
        this.defaultResponse(result, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getceemeagaincustomer(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `getceemeagaincustomer`
    axios
      .post(config.serverUrl + url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  updateceemeagaincustomerstatus: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'updateceemeagaincustomerstatus', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postceemeagainintent: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'ceemeagainintent', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putceemeagainintent: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'ceemeagainintent', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getceemeagainintent(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `ceemeagainintent`
    axios
      .get(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleteceemeagaincustomer(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `deleteceemeagaincustomer`
    axios
      .delete(config.serverUrl + url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getbranchlocation(data, callback) {
    let url = `branchlocation`
    axios
      .get(config.serverUrl + url, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  savebranchlocation(data, callback) {
    let url = config.serverUrl + 'branchlocation'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  // savebranchlocation(data, callback) {
  //   let url = config.serverUrl + 'branchlocation'
  //   axios
  //     .post(url, data.body, {
  //       headers: {
  //         AUTHORIZATION: store.getters.securityToken
  //       },
  //       params: data.params
  //     })
  //     .then(response => {
  //       this.defaultResponse(response, callback)
  //     })
  //     .catch(e => {
  //       this.defaultError(e, callback)
  //     })
  // },
  getGroupDefaultChatlogs: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    // axios.defaults.timeout = 60000;
    axios
      .get(config.serverUrl + 'groupdefaultchatlogs', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getshippop(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'shippop', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  superjeewrankedvoting: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    // axios.defaults.timeout = 60000;
    axios
      .get(config.serverUrl + 'superjeewrankedvoting', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        callback(e)
      })
  },
  saveshippop(data, callback) {
    let url = config.serverUrl + 'shippop'
    axios
      .put(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  shippopcheckorderlist(data, callback) {
    let url = config.serverUrl + 'shippopcheckorderlist'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  shippopbooking(data, callback) {
    let url = config.serverUrl + 'shippopbooking'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  shippopconfirm(data, callback) {
    let url = config.serverUrl + 'shippopconfirm'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  shippopbookingrefno(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'shippopbookingrefno', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  superjeewrankedvotingBycompetitorid: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    // axios.defaults.timeout = 60000;
    axios
      .get(config.serverUrl + 'superjeewrankedvotingBycompetitorid', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getgbprimecredit(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'gbprimecredit', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  savegbprimecredit(data, callback) {
    let url = config.serverUrl + 'gbprimecredit'
    axios
      .put(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getakita(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'akitatoken', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postcentralhremployee(data, callback) {
    let url = config.serverUrl + 'centralhremployee'
    axios
      .post(url, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  saveakita(data, callback) {
    let url = config.serverUrl + 'akitatoken'
    axios
      .put(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getcentralhremployee(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'centralhremployee', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getipststudent(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'ipststudent', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putbeavermanuserinfo(data, callback) {
    let url = config.serverUrl + 'beavermanuserinfo'
    axios
      .put(url, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putassignstatusByadminid(data, callback) {
    let url = config.serverUrl + 'assignstatusByadminid'
    axios
      .put(url, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  gbcreaterefnofromupgradepremiumcms(data, callback) {
    let url = config.serverUrl + 'gbcreaterefnofromupgradepremiumcms'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params,
        responseType: 'arraybuffer'
      })
      .then((response) => {
        callback(null, response)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  linemessagecontenttypefile(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'linemessagecontenttypefile', { params: data })
      .then((response) => {
        callback(null, response)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  bangkokbankapplicantall(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'bangkokbankapplicantall', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleteAstonAdmin(data, callback) {
    let url = config.serverUrl + 'astonadmins'
    axios
      .delete(url, { data: data.body })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  toggleFacebookSyncTags(data, callback) {
    let url = config.serverUrl + 'synctagsfacebook_status'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getchillpainai_influencer(data, callback) {
    let url = config.serverUrl + 'chillpainai_influencer'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postchillpainai_influencer(data, callback) {
    let url = config.serverUrl + 'chillpainai_influencer'
    axios
      .post(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putchillpainai_influencer(data, callback) {
    let url = config.serverUrl + 'chillpainai_influencer'
    axios
      .put(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putchillpainai_influencer_password(data, callback) {
    let url = config.serverUrl + 'chillpainai_influencer_password'
    axios
      .put(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deletechillpainai_influencer(data, callback) {
    let url = config.serverUrl + 'chillpainai_influencer'
    axios
      .delete(url, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getshopaddressarray(data, callback) {
    let url = config.serverUrl + 'shopaddressarray'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  saveshopaddressarray(data, callback) {
    let url = config.serverUrl + 'shopaddressarray'
    axios
      .put(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getshopaddressarray(data, callback) {
    let url = config.serverUrl + 'shopaddressarray'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  saveshopaddressarray(data, callback) {
    let url = config.serverUrl + 'shopaddressarray'
    axios
      .put(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postgpkmemberdashboard(data, callback) {
    let url = config.serverUrl + 'gpkmemberdashboard'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postgpkmemberregisterdashboard(data, callback) {
    let url = config.serverUrl + 'gpkmemberregisterdashboard'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postgpkdiscountusagehistorydashboard(data, callback) {
    let url = config.serverUrl + 'gpkdiscountusagehistorydashboard'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  postterovoteparticipants(data, callback) {
    let url = config.serverUrl + 'terovoteparticipants'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postterovoteresult(data, callback) {
    let url = config.serverUrl + 'terovoteresult'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getrunkanmemberdashboard(data, callback) {
    let url = config.serverUrl + 'runkanmemberdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getrunkanprojects(data, callback) {
    let url = config.serverUrl + 'runkanprojects'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getrunkanparticipantsdashboard(data, callback) {
    let url = config.serverUrl + 'runkanparticipantsdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getrunkanattachrunningresultdashboard(data, callback) {
    let url = config.serverUrl + 'runkanattachrunningresultdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  post_total_users(data, callback) {
    const url = `${config.serverUrl}api/analytics/total_users`
    axios
      .post(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  runkanadminupdaterunningresult(data, callback) {
    let url = config.serverUrl + 'runkanadminupdaterunningresult'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putuserrealname(data, callback) {
    let url = config.serverUrl + 'userrealname'
    axios
      .put(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putusercardnumber(data, callback) {
    let url = config.serverUrl + 'usercardnumber'
    axios
      .put(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  putusergender(data, callback) {
    let url = `${config.serverUrl}page/${data.params.pageid}/${data.params.usersid}/update-user-info`
    axios
      .put(url, data.body)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putmjdcustomerdashboard(data, callback) {
    let url = config.serverUrl + 'mjdcustomerdashboard'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  putmjdcustomerprojectdashboard(data, callback) {
    let url = config.serverUrl + 'mjdcustomerprojectdashboard'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deletemjdcustomerprojectdashboard(data, callback) {
    let url = config.serverUrl + 'mjdcustomerprojectdashboard'
    axios
      .delete(url, {
        params: data
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  putmjdservicescategory(data, callback) {
    let url = config.serverUrl + 'mjdservicescategory'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postmjdservicescategory(data, callback) {
    let url = config.serverUrl + 'mjdservicescategory'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postmjdservicesproduct(data, callback) {
    let url = config.serverUrl + 'mjdservicesproduct'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getmjdservicesproduct(data, callback) {
    let url = config.serverUrl + 'mjdservicesproduct'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getmjdcustomerprojectdashboard(data, callback) {
    let url = config.serverUrl + 'mjdcustomerprojectdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deletemjdservicesproduct(data, callback) {
    let url = config.serverUrl + 'mjdservicesproduct'
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putmjdservicesproduct(data, callback) {
    let url = config.serverUrl + 'mjdservicesproduct'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postmjdimportaccounts(data, callback) {
    let url = config.serverUrl + 'mjdimportaccounts'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putmjdappointmentchangedByadmin(data, callback) {
    let url = config.serverUrl + 'mjdappointmentchangedByadmin'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postmjdadmincreateappointment(data, callback) {
    let url = config.serverUrl + 'mjdadmincreateappointment'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postmjdaddaccountByadmin(data, callback) {
    let url = config.serverUrl + 'mjdaddaccountByadmin'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getmjdcustomerdashboard(data, callback) {
    let url = config.serverUrl + 'mjdcustomerdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getmjdappointmentchangeproject(data, callback) {
    let url = config.serverUrl + 'mjdappointmentchangeproject'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getmjdappointmentchangeservice(data, callback) {
    let url = config.serverUrl + 'mjdappointmentchangeservice'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getmjdservicescategory(data, callback) {
    let url = config.serverUrl + 'mjdservicescategory'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deletemjdservicescategory(data, callback) {
    let url = config.serverUrl + 'mjdservicescategory'
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deletemjdcustomerdashboard(data, callback) {
    let url = config.serverUrl + 'mjdcustomerdashboard'
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getmjdappointmentsdshboard(data, callback) {
    let url = config.serverUrl + 'mjdappointmentsdshboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deletemjdappointmentdeleteByadmin(data, callback) {
    let url = config.serverUrl + 'mjdappointmentdeleteByadmin'
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  get_nvbb_product_amount_by_date(data, callback) {
    let url = config.serverUrl + 'nvbb_product_amount_by_date'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getCountActiveUser(data, callback) {
    let url = `${config.serverUrl}getcountactiveuser`
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  employeelogindashboard(data, callback) {
    let url = config.serverUrl + 'employeelogindashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  employeefilterinfo(data, callback) {
    let url = config.serverUrl + 'employeefilterinfo'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  post_total_users_calculate(data, callback) {
    const url = `${config.serverUrl}api/analytics/total_users_calculate`
    axios
      .post(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  post_total_new_users(data, callback) {
    const url = `${config.serverUrl}api/analytics/total_new_users`
    axios
      .post(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  post_report_inbox_user_by_date(data, callback) {
    let url = config.serverUrl + 'report_inbox_user_by_date'
    axios
      .post(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  post_report_comment_user_by_date(data, callback) {
    let url = config.serverUrl + 'report_comment_user_by_date'
    axios
      .post(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  post_report_inbox_user_by_time(data, callback) {
    let url = config.serverUrl + 'report_inbox_user_by_time'
    axios
      .post(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  post_report_comment_user_by_time(data, callback) {
    let url = config.serverUrl + 'report_comment_user_by_time'
    axios
      .post(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  post_report_inbox_message(data, callback) {
    let url = config.serverUrl + 'report_inbox_message'
    axios
      .post(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  post_report_comment_message(data, callback) {
    let url = config.serverUrl + 'report_comment_message'
    axios
      .post(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  post_all_users(data, callback) {
    let url = config.serverUrl + 'all_users'
    axios
      .post(url, data.body, {
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  post_all_users_calculate(data, callback) {
    let url = config.serverUrl + 'all_users_calculate'
    axios
      .post(url, data.body, {
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  runkanadminupdatedistancesrunningresult(data, callback) {
    let url = config.serverUrl + 'runkanadminupdatedistancesrunningresult'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  scgdistributiongetinterestusers(data, callback) {
    let url = config.serverUrl + 'scgdistribution/getinterestusers'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  postmjdaddcustomerprojectByadmin(data, callback) {
    let url = config.serverUrl + 'mjdaddcustomerprojectByadmin'
    axios
      .post(url, data, {})
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  customerrequestquotationdashboard(data, callback) {
    let url = config.serverUrl + 'customerrequestquotationdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  dealersendquotationdashboard(data, callback) {
    let url = config.serverUrl + 'dealersendquotationdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  orderscompletepaymentdashboard(data, callback) {
    let url = config.serverUrl + 'orderscompletepaymentdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ordersshippingdashboard(data, callback) {
    let url = config.serverUrl + 'ordersshippingdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  dealerregistersuccessdashboard(data, callback) {
    let url = config.serverUrl + 'dealerregistersuccessdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  provincedealerdashboard(data, callback) {
    let url = config.serverUrl + 'provincedealerdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  provinceofdealerquotationdashboard(data, callback) {
    let url = config.serverUrl + 'provinceofdealerquotationdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ordersummarywithoutshippingdashboard(data, callback) {
    let url = config.serverUrl + 'ordersummarywithoutshippingdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  painterregistersuccessdashboard(data, callback) {
    let url = config.serverUrl + 'painterregistersuccessdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  provincepainterdashboard(data, callback) {
    let url = config.serverUrl + 'provincepainterdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  provinceofsearchpainterdashboard(data, callback) {
    let url = config.serverUrl + 'provinceofsearchpainterdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  searchpainterdashboard(data, callback) {
    let url = config.serverUrl + 'searchpainterdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  painterconfirmjobdashboard(data, callback) {
    let url = config.serverUrl + 'painterconfirmjobdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  painterreviewjobdashboard(data, callback) {
    let url = config.serverUrl + 'painterreviewjobdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  paintersendstartdatejobdashboard(data, callback) {
    let url = config.serverUrl + 'paintersendstartdatejobdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  paintercanceledjobdashboard(data, callback) {
    let url = config.serverUrl + 'paintercanceledjobdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  painterupdatejobdashboard(data, callback) {
    let url = config.serverUrl + 'painterupdatejobdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  scgdistributionimportproducts(data, callback) {
    let url = config.serverUrl + 'scgdistribution/importproducts'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        if (e.response.data.reason) {
          const reason = e.response.data.reason
          if (typeof reason == 'object' && reason.code) {
            Vue.swal.fire({
              text: `${reason.code}${reason.constraint ? ` - ${reason.constraint}` : ''} : ${
                reason.detail
              }${reason.line ? ` (${reason.line})` : ''}`
            })
          } else {
            Vue.swal.fire({ text: reason })
          }
        }
        this.defaultError(e, callback)
      })
  },
  getmjdexportcustomerdashboard(data, callback) {
    let url = config.serverUrl + 'mjdexportcustomerdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  channeltoquotationpaintersdashboard(data, callback) {
    let url = config.serverUrl + 'channeltoquotationpaintersdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  channeltoquotationdealerdashboard(data, callback) {
    let url = config.serverUrl + 'channeltoquotationdealerdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  scgdistributionExportProducts(data, callback) {
    let url = config.serverUrl + 'scgdistribution/exportproductsbycategoryid'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putnvbbquotahistory(data, callback) {
    let url = config.serverUrl + 'nvbbquotahistory'
    axios
      .put(url, data.body, { params: data.params })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2checkstatus(data, callback) {
    let path =
      store.state.selectedBot.theme === 'ustore'
        ? 'ustore/cms/validateStatusCheckOutBeforeLogout'
        : 'com7/validate-status-checkout'
    let url = config.serverUrl + path
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2checkincheckout(data, callback) {
    let path =
      store.state.selectedBot.theme === 'ustore'
        ? 'ustore/cms/checkInCheckOut'
        : 'com7/checkin-checkout'
    let url = config.serverUrl + path
    axios
      .post(url, data)
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  com7importproducts(data, callback) {
    let path =
      store.state.selectedBot.theme === 'ustore'
        ? 'ustore/cms/importProducts'
        : 'com7/import-products'
    let url = config.serverUrl + path
    axios
      .post(url, data)
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  com7importbranchs(data, callback) {
    let path =
      store.state.selectedBot.theme === 'ustore'
        ? 'ustore/cms/importBranchs'
        : 'com7/import-branchs'
    let url = config.serverUrl + path
    axios
      .post(url, data)
      .then((response) => {
        if (response.status == 200) callback(null, response.data)

        // this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  com7getbranchs(data, callback) {
    let path = store.state.selectedBot.theme === 'ustore' ? 'ustore/cms/branchs' : 'com7/branchs'
    let url = config.serverUrl + path
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  com7getproducts(data, callback) {
    let path = store.state.selectedBot.theme === 'ustore' ? 'ustore/cms/products' : 'com7/products'
    let url = config.serverUrl + path
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) callback(null, response.data)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  mjdallpointscustomerdashboard(data, callback) {
    let url = config.serverUrl + 'mjdallpointscustomerdashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  // ticket2getuserthread is not use
  ticket2getuserthread(data, callback) {
    let url = config.serverUrl + 'com7/usersthread'
    axios
      .get(url, { params: data })
      .then((response) => {
        if (response.status == 200) this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  ticket2getLiveChatUsers: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let path =
      store.state.selectedBot.theme === 'ustore' ? 'ustore/cms/usersthread' : 'com7/usersthread'
    let url = config.serverUrl + path
    axios
      .post(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  cottoGetUserthread: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let path = 'cotto/usersthread'
    let url = config.serverUrl + path
    axios
      .post(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CreateTicket: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'ustore/cms/createTicketByAdmin', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2TransferTicket: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'ustore/cms/transferTicket', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2UpdateTicket: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'ustore/cms/updateTicketData', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2getticket: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let path = store.state.selectedBot.theme === 'ustore' ? 'ustore/cms/getTickets' : 'com7/tickets'
    let url = config.serverUrl + path
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deletecmsviewcartbyid: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'cmsviewcartbyid', { data: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  com7checkincheckoutlog: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let path =
      store.state.selectedBot.theme === 'ustore'
        ? 'ustore/cms/getCheckInCheckOutLogByAdminId'
        : 'com7/checkIncheckOutLog'
    let url = config.serverUrl + path

    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  com7ticketworklog: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let path =
      store.state.selectedBot.theme === 'ustore'
        ? 'ustore/cms/getAdminWorkLogByAdminId'
        : 'com7/workLog'
    let url = config.serverUrl + path
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  com7ticketbyagent: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let path =
      store.state.selectedBot.theme === 'ustore'
        ? 'ustore/cms/getTicketsByAgent'
        : 'com7/ticketsByAgent'
    axios
      .get(config.serverUrl + path, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  com7checkIncheckOutStatByAdminId: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let path =
      store.state.selectedBot.theme === 'ustore'
        ? 'ustore/cms/getCheckInCheckOutStatByAdminId'
        : 'com7/checkIncheckOutStatByAdminId'
    axios
      .get(config.serverUrl + path, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  commonNewTicketCheckIncheckOutStatByAdminId: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let path = 'commonnewticket/cms/checkIncheckOutStatByAdminId'
    axios
      .get(`${config.serverUrl}${path}`, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getProductToaToLiveChat: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'getProductToaToLiveChat', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  com7GetTicketsByStatus: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let path =
      store.state.selectedBot.theme === 'ustore'
        ? 'ustore/cms/getTicketsByStatus'
        : 'com7/getTicketsByStatus'
    let url = config.serverUrl + path
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  com7GetTicketsCloseCase: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let path =
      store.state.selectedBot.theme === 'ustore'
        ? 'ustore/cms/getTicketsCloseCase'
        : 'com7/getTicketsCloseCase'
    let url = config.serverUrl + path
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  com7GetTicketsCloseCaseDetailByAdmin: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let path =
      store.state.selectedBot.theme === 'ustore'
        ? 'ustore/cms/getTicketsCloseCaseDetailByAdmin'
        : 'com7/getTicketsCloseCaseDetailByAdmin'
    let url = config.serverUrl + path
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  toaSendProductToCustomerByAdmin: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toaSendProductToCustomerByAdmin', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  com7setWorkingHours: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let path =
      store.state.selectedBot.theme === 'ustore' ? 'common/setWorkingHours' : 'com7/setWorkingHours'
    let url = config.serverUrl + path
    if (store.state.selectedBot.theme === 'ustore') {
      axios
        .post(url, data)
        .then((response) => {
          this.defaultResponse(response, callback)
        })
        .catch((e) => {
          this.defaultError(e, callback)
        })
    } else {
      axios
        .put(url, data)
        .then((response) => {
          this.defaultResponse(response, callback)
        })
        .catch((e) => {
          this.defaultError(e, callback)
        })
    }
  },
  com7setAnswerAfterHours: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let path =
      store.state.selectedBot.theme === 'ustore'
        ? 'common/setWorkingHours'
        : 'com7/setAnswerAfterHours'
    let url = config.serverUrl + path
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  com7PostAnswerAfterHours: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let path = 'common/setAnswerAfterHours'
    let url = config.serverUrl + path
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  postmjdclearaccountbyadmin(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'mjdclearaccountbyadmin', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  com7updateBranchStatus: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'com7/updateBranchStatus', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  gettoacrmBranch: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/branchs-dashboard', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  createtoacrmBranch: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/create-branch', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  edittoacrmBranch: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'toacrm/edit-branch', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  toacrmimportbranch: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/import-branchs', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deletebranchtoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'toacrm/delete-branch', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getmembertoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/members-dashboard', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  editmembertoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'toacrm/edit-member', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  creatrewardcategorytoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/create-reward-category', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  editrewardcategorytoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'toacrm/edit-reward-category', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getrewardcategorytoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/reward-category-dashboard', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  editrewardcategorytoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'toacrm/edit-reward-category', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  createrewardproducttoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/create-reward-product', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  editrewardproducttoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'toacrm/edit-reward-product', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getrewardproducttoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/reward-product-dashboard', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getproducttoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/products-dashboard', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  importproducttoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/import-products', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  createproducttoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/create-product', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  editproducttoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'toacrm/edit-product', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteproducttoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'toacrm/delete-product', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleterewardcategorytoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'toacrm/delete-reward-category', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleterewardproducttoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'toacrm/delete-reward-product', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getpointdatatoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'toacrm/point-dashboard', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getcom7pagereport_summary: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'pagereport_summary', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getcom7pagereport_activeusers_bydate: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'pagereport_activeusers_bydate', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getcom7pagereport_activeusers_bytime: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'pagereport_activeusers_bytime', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getcom7pagereport_intents: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'pagereport_intents', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getcom7intents: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'intents', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getcom7userstatus: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'userstatus', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getcom7getallusers: function (data, callback) {
    let url = config.serverUrl + 'getallusers'
    var body = {
      ...data,
      ...this.joinFilterToObject(data['filter'], store.getters.getPackage == 'premium')
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, body)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  importpaymentreceipttemplate_toacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/import-payment-receipt-templates', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getpaymentreceipttemplate_toacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/payment-receipt-templates-dashboard', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  setwelcomepointtoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/set-welcome-points', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  setwelcomepointStatusToacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/set-welcome-points-status', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  setexpirepointtoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/set-points-expiration', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  setSlipUploadExpireToacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(`${config.serverUrl}toacrm/set-slip-upload-expiration`, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  setpurchasepointtoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/set-purchase-amount', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getapprovereceipttoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/approve-receipt-dashboard', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  Adminapprovereceipttoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/approve-receipt-status-admin', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  Managerapprovereceipttoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/approve-receipt-status-manager', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  Accountingapprovereceipttoacrm: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toacrm/approve-receipt-status-accounting', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  importproductkeyword(data, callback) {
    let url = config.serverUrl + 'importfile/importproductkeyword'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getYasaleMember(data, callback) {
    let url = config.serverUrl + 'yasale/member-dashboard'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getYasaleReward(data, callback) {
    let url = config.serverUrl + 'yasale/reward-dashboard'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },

  getYasaleMemberPoint(data, callback) {
    let url = config.serverUrl + 'yasale/rewardpoints-transaction-dashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getYasaleImeiAvailable(data, callback) {
    let url = config.serverUrl + 'yasale/imei-available'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getYasaleImei(data, callback) {
    let url = config.serverUrl + 'yasale/imei-dashboard'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  importYasaleImei(data, callback) {
    let url = config.serverUrl + 'yasale/import-imei'
    axios
      .post(url, data)
      .then((response) => {
        callback(response.data)
      })
      .catch((e) => {
        // console.log(swal)
        callback(response.data)
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  deleteYasaleImei(data, callback) {
    let url = config.serverUrl + 'yasale/delete-imei'
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  deleteYasaleMember(data, callback) {
    let url = config.serverUrl + 'yasale/delete-member'
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  createYasaleImei(data, callback) {
    let url = config.serverUrl + 'yasale/create-imei'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getYasaleCampaign(data, callback) {
    let url = config.serverUrl + 'yasale/campaign-dashboard'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getYasaleCampaignDetails(data, callback) {
    let url = config.serverUrl + 'yasale/campaign-details-dashboard'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  updateYasaleImei(data, callback) {
    let url = config.serverUrl + 'yasale/edit-imei'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  updateYasaleMember(data, callback) {
    let url = config.serverUrl + 'yasale/edit-member'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  createYasaleMemberPoint(data, callback) {
    let url = config.serverUrl + 'yasale/add-member-points'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  updateMemberPhoneYasale(data, callback) {
    let url = config.serverUrl + 'yasale/phone'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  powerbuyAddChannelFacebook(data, callback) {
    let url = config.serverUrl + 'powerbuy/add-channel-facebook'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },

  powerbuyAddChannelInstagram(data, callback) {
    let url = config.serverUrl + 'powerbuy/add-channel-instagram'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        if (e.response.data) Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuySendFacebookPost(data, callback) {
    let url = config.serverUrl + 'powerbuy/facebook-publish-pages-post'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyEditFacebookPublishPost(data, callback) {
    let url = config.serverUrl + 'powerbuy/facebook-publish-pages-post'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  powerbuyDeleteFacebookPublishPost(payload, callback) {
    let url = config.serverUrl + 'powerbuy/facebook-publish-pages-post'
    axios
      .delete(url, { data: payload })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },

  powerbuySendFacebookSharePost(data, callback) {
    let url = config.serverUrl + 'powerbuy/facebook-share-post'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyCreateFacebookPost(data, callback) {
    let url = config.serverUrl + 'powerbuy/create-facebook-post'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyCreateInstagramPost(data, callback) {
    let url = config.serverUrl + 'powerbuy/create-instagram-post'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyCreateFacebookShearPost(data, callback) {
    let url = config.serverUrl + 'powerbuy/create-facebook-share-post'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyEditFacebookPost(data, callback) {
    let url = config.serverUrl + 'powerbuy/edit-facebook-post'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyEditInstagramPost(data, callback) {
    let url = config.serverUrl + 'powerbuy/edit-instagram-post'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        if (e.response.data) Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyEditFacebookShearPost(data, callback) {
    let url = config.serverUrl + 'powerbuy/edit-facebook-share-post'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyGetFacebookPostManagement(params, callback) {
    let url = config.serverUrl + 'powerbuy/facebook-post-management'
    axios
      .get(url, { params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyGetFacebooksharePostManagement(params, callback) {
    let url = config.serverUrl + 'powerbuy/facebook-share-post-management'
    axios
      .get(url, { params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyGetInstagramPostManagement(params, callback) {
    let url = config.serverUrl + 'powerbuy/instagram-post-management'
    axios
      .get(url, { params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        console.log(e.response)
        if (e.response.data) Vue.swal.fire({ text: e.response.data.reason || '' })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyGetChannel(params, callback) {
    let url = config.serverUrl + 'powerbuy/channels'
    axios
      .get(url, { params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyGetFollowers(params, callback) {
    let url = config.serverUrl + 'powerbuy/channel-followers'
    axios
      .get(url, { params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyGetFacebookLike(params, callback) {
    let url = config.serverUrl + 'powerbuy/facebook-page-likes'
    axios
      .get(url, { params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyGetLineQuota(params, callback) {
    let url = config.serverUrl + 'powerbuy/line-quota-available'
    axios
      .get(url, { params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyAddChannelGroup(data, callback) {
    let url = config.serverUrl + 'powerbuy/add-channel-group'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyAddChannelLine(data, callback) {
    let url = config.serverUrl + 'powerbuy/add-channel-line'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  powerbuyImportLineFollower(data, callback) {
    let url = config.serverUrl + 'powerbuy/import-line-follower'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  postinsertusersfrominbox(data, callback) {
    let url = config.serverUrl + 'insertusersfrominbox'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  postinsertusersfromdone(data, callback) {
    let url = config.serverUrl + 'insertusersfromdone'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  commonSetWorkingHours(data, callback) {
    let url = config.serverUrl + 'common/setWorkingHours'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  importYasalePoints(data, callback) {
    let url = config.serverUrl + 'yasale/import-points'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  createPowerbuyGroup(data, callback) {
    let url = config.serverUrl + 'powerbuy/create-group'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  createPowerbuyLineBroadcast(data, callback) {
    let url = config.serverUrl + 'powerbuy/create-line-broadcast'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  editPowerbuyLineBroadcast(data, callback) {
    let url = config.serverUrl + 'powerbuy/edit-line-broadcast'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  deletePowerbuyLineBroadcast(params, callback) {
    let url = config.serverUrl + 'powerbuy/delete-line-broadcast'
    axios
      .delete(url, { params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getPowerbuyLineBroadcast(params, callback) {
    let url = config.serverUrl + 'powerbuy/line-broadcast-management'
    axios
      .get(url, { params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  editPowerbuyGroup(data, callback) {
    let url = config.serverUrl + 'powerbuy/edit-group'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getPowerbuyGroup(data, callback) {
    let url = config.serverUrl + 'powerbuy/groups'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  deletePowerbuyGroup(data, callback) {
    let url = config.serverUrl + 'powerbuy/delete-group'
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  deletePowerbuyPost(data, callback) {
    let url = config.serverUrl + 'powerbuy/delete-facebook-post'
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  deletePowerbuyInstagramPost(data, callback) {
    let url = config.serverUrl + 'powerbuy/delete-instagram-post'
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },

  deletePowerbuyShearPost(data, callback) {
    let url = config.serverUrl + 'powerbuy/delete-facebook-share-post'
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  deletePowerbuyChannel(data, callback) {
    let url = config.serverUrl + 'powerbuy/delete-channel'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getPowerbuyInstagramCheckQuota(data, callback) {
    let url = config.serverUrl + 'powerbuy/instagram-post-quota'
    axios
      .post(url, { ...data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        if (e.response.data) Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getPowerbuyFacebookImpression(data, callback) {
    let url = config.serverUrl + 'powerbuy/impression-facebook-details'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getPowerbuyLineReach(data, callback) {
    let url = config.serverUrl + 'powerbuy/reach-line-details'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getToacrmCheckAvailableRef(data, callback) {
    let url = config.serverUrl + 'toacrm/check-duplicate-refno-paymentreceipt'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getPowerbuyFacebookPost(data, callback) {
    let url = config.serverUrl + 'powerbuy/topic-facebook-post'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getPowerbuyLineReachTitle(data, callback) {
    let url = config.serverUrl + 'powerbuy/reach-line-title'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async getPowerbuyFacebookImpressionPostDetail(data) {
    return new Promise((resolve, reject) => {
      let url = config.serverUrl + 'powerbuy/impression-facebook-post-details'
      axios
        .get(url, { params: data })
        .then(async (response) => {
          if (response.status == 200) {
            resolve(response.data)
          } else {
            await Vue.swal.fire({
              text: response.data.reason
            })
            resolve(null)
          }
        })
        .catch((e) => {
          Vue.swal.fire({ text: e.response.data.reason })
          resolve(null)
          // this.defaultError(e, callback)
        })
    })
  },
  async getFacebookCommentByPostId(postid, data) {
    return new Promise((resolve, reject) => {
      let url = 'https://graph.facebook.com/' + postid + '/comments'
      axios
        .get(url, { params: data })
        .then(async (response) => {
          if (response.status == 200) {
            resolve(response.data)
          } else {
            await Vue.swal.fire({
              text: response.data.reason
            })
            resolve(null)
          }
        })
        .catch((e) => {
          Vue.swal.fire({ text: e.response.data.reason })
          resolve(null)
          // this.defaultError(e, callback)
        })
    })
  },
  async getFacebookReactionsByPostId(postid, data) {
    return new Promise((resolve, reject) => {
      let url = 'https://graph.facebook.com/' + postid + '/reactions'
      axios
        .get(url, { params: data })
        .then(async (response) => {
          if (response.status == 200) {
            resolve(response.data)
          } else {
            await Vue.swal.fire({
              text: response.data.reason
            })
            resolve(null)
          }
        })
        .catch((e) => {
          Vue.swal.fire({ text: e.response.data.reason })
          resolve(null)
          // this.defaultError(e, callback)
        })
    })
  },
  async getFacebookPostByPostId(postid, data) {
    return new Promise((resolve, reject) => {
      let url = 'https://graph.facebook.com/' + postid
      axios
        .get(url, { params: data })
        .then(async (response) => {
          if (response.status == 200) {
            resolve(response.data)
          } else {
            await Vue.swal.fire({
              text: response.data.reason
            })
            resolve(null)
          }
        })
        .catch((e) => {
          Vue.swal.fire({ text: e.response.data.reason })
          resolve(null)
          // this.defaultError(e, callback)
        })
    })
  },
  async getPowerbuyFacebookComment(data) {
    return new Promise((resolve) => {
      let url = config.serverUrl + 'powerbuy/impression-facebook-comment-details'
      axios
        .get(url, { params: data })
        .then(async (response) => {
          if (response.data.responsecode == 200) {
            resolve(response.data)
          } else {
            await Vue.swal.fire({
              text: response.data.reason
            })
          }
        })
        .catch((e) => {
          Vue.swal.fire({ text: e.response.data.reason })
          // this.defaultError(e, callback)
        })
    })
  },
  async getPowerbuyFacebookLike(data) {
    return new Promise((resolve) => {
      let url = config.serverUrl + 'powerbuy/impression-facebook-like-details'
      axios
        .get(url, { params: data })
        .then(async (response) => {
          if (response.data.responsecode == 200) {
            resolve(response.data)
          } else {
            await Vue.swal.fire({
              text: response.data.reason
            })
          }
        })
        .catch((e) => {
          Vue.swal.fire({ text: e.response.data.reason })
          // this.defaultError(e, callback)
        })
    })
  },
  async getPowerbuyFacebookShare(data) {
    return new Promise((resolve) => {
      let url = config.serverUrl + 'powerbuy/impression-facebook-share-details'
      axios
        .get(url, { params: data })
        .then(async (response) => {
          if (response.data.responsecode == 200) {
            resolve(response.data)
          } else {
            await Vue.swal.fire({
              text: response.data.reason
            })
          }
        })
        .catch((e) => {
          Vue.swal.fire({ text: e.response.data.reason })
          // this.defaultError(e, callback)
        })
    })
  },
  async editToacrmMemberStatus(data, callback) {
    let url = config.serverUrl + 'toacrm/edit-member_status'
    axios
      .put(url, data.data, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },

  async nvbb_pre_order_stock_update(data) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      const response = await axios.put(config.serverUrl + 'nvbb_pre_order_stock_update', data)
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async atomicboyscorebyuserid(userid) {
    let url = `${config.serverUrl}atomicboyscorebyuserid?userid=${userid}&pageid=105479814959388`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },

  async oabProductList(body) {
    let url = `${config.serverUrl}oab/product/list`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.post(url, body)
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },

  async updateUserSession(data) {
    let url = `${config.serverUrl}updateusersession`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.post(url, data)
      console.log(res.data.responsecode)
      return res.data.responsecode
      // if (res.data.responsecode == 204) {
      //   return res.data.data
      // }
    } catch (error) {
      console.error(error)
    }
  },

  async getJsonlog(userid) {
    let url = `${config.serverUrl}getJsonlog/${userid}?pageid=105479814959388`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },

  async getatomicboyscoreuser(userid) {
    let url = config.serverUrl + `getatomicboyscoreuser/${userid}?pageid=105479814959388`
    // const headers = {
    //   Authorization: store.getters.securityToken
    // }
    let res = await axios.get(url).catch((e) => console.error(e))
    if (res.data.responsecode == 200) {
      return res.data.data
    }
  },

  async generalipdpaCreateConsent(data, callback) {
    let url = config.serverUrl + 'generalipdpa/createConsent'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async generalipdpaUpdateConsent(data, callback) {
    let url = config.serverUrl + 'generalipdpa/updateConsent'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async generalipdpaActiveConsent(data, callback) {
    let url = config.serverUrl + 'generalipdpa/activeConsent'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async generalipdpaGetConsent(data, callback) {
    let url = config.serverUrl + 'generalipdpa/allConsent'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenTechnicianList(data, callback) {
    let url = config.serverUrl + 'kingkitchen/cms/technicianList'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenGetOrders(data, callback) {
    let url = config.serverUrl + 'kingkitchen/cms/orders'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchengetTechnicianOrderSatisfaction(data, callback) {
    let url = config.serverUrl + 'kingkitchen/getTechnicianOrderSatisfaction'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchengetsetting(data, callback) {
    let url = config.serverUrl + 'kingkitchen/cms/setting'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchengetemployee(data, callback) {
    let url = config.serverUrl + 'kingkitchen/cms/employee'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchengetcustomer(data, callback) {
    let url = config.serverUrl + 'kingkitchen/cms/customer'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenverifyCheckListOrder(data, callback) {
    let url = config.serverUrl + 'kingkitchen/cms/verifyCheckListOrder'
    axios
      .put(url, { ...data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenVerifyDocumentCheckListOrder(data) {
    const url = `${config.serverUrl}kingkitchen/cms/verifyDocumentCheckListOrder`

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      const response = await axios.put(url, { ...data })
      return await this.defaultResponse2(response)
    } catch (error) {
      return this.defaultError2(error)
    }
  },
  async kingkitchenupdateOrderStatusByAdmin(data, callback) {
    let url = config.serverUrl + 'kingkitchen/cms/updateOrderStatusByAdmin'
    axios
      .put(url, { ...data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenupdateNotifyBeforeInstallDate(data, callback) {
    let url = config.serverUrl + 'kingkitchen/cms/updateNotifyBeforeInstallDate'
    axios
      .put(url, { ...data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenupdateNotifyBeforeInstallMessage(data, callback) {
    let url = config.serverUrl + 'kingkitchen/cms/updateNotifyBeforeInstallMessage'
    axios
      .put(url, { ...data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenupdateNotifyAfterInstallDate(data, callback) {
    let url = config.serverUrl + 'kingkitchen/cms/updateNotifyAfterInstallDate'
    axios
      .put(url, { ...data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenupdateNotifyAfterInstallMessage(data, callback) {
    let url = config.serverUrl + 'kingkitchen/cms/updateNotifyAfterInstallMessage'
    axios
      .put(url, { ...data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenchangeAppointmentOrderByAdmin(data, callback) {
    let url = config.serverUrl + 'kingkitchen/cms/changeAppointmentOrderByAdmin'
    axios
      .put(url, { ...data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenapplyOrderToTechnician(data, callback) {
    let url = config.serverUrl + 'kingkitchen/cms/applyOrderToTechnician'
    axios
      .put(url, { ...data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenapplyAppointmentTimeToOrder(data, callback) {
    let url = config.serverUrl + 'kingkitchen/cms/applyAppointmentTimeToOrder'
    axios
      .put(url, { ...data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenSetHoliday(data, callback) {
    let url = config.serverUrl + 'kingkitchen/holidays'
    axios
      .post(url, { ...data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenGetHoliday(data, callback) {
    let url = config.serverUrl + 'kingkitchen/holidays'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenGetQueue(data, callback) {
    let url = config.serverUrl + 'kingkitchen/setQueue'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenSetQueue(data, callback) {
    let url = config.serverUrl + 'kingkitchen/setQueue'
    axios
      .post(url, { ...data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenAddEmployeeId(data, callback) {
    let url = `${config.serverUrl}kingkitchen/addEmployeeMemberByAdmin`
    axios
      .post(url, { ...data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async kingkitchenUnlinkMember(data, callback) {
    let url = `${config.serverUrl}kingkitchen/unlinkmember`
    axios
      .post(url, { ...data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async foodguruGetCustomer(data, callback) {
    let url = config.serverUrl + 'foodguru/cms/customerDashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        Vue.swal.fire({ text: e.response.data.reason })
        this.defaultError(e, callback)
      })
  },
  async foodguruGetcustomerOrders(data, callback) {
    let url = config.serverUrl + 'foodguru/cms/customerOrdersDashboard'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        // console.log(swal)
        Vue.swal.fire({ text: e.response.data.reason })
        // swal().fire({

        // })
        this.defaultError(e, callback)
      })
  },
  getshippop(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'shippop', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  saveshippop(data, callback) {
    let url = config.serverUrl + 'shippop'
    axios
      .put(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  shippopcheckorderlist(data, callback) {
    let url = config.serverUrl + 'shippopcheckorderlist'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  shippopbooking(data, callback) {
    let url = config.serverUrl + 'shippopbooking'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  shippopconfirm(data, callback) {
    let url = config.serverUrl + 'shippopconfirm'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  shippopbookingrefno(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'shippopbookingrefno', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  shippopaddresslabel(data, callback) {
    let url = config.serverUrl + 'shippopaddresslabel'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getshippopaddresslabel(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'shippopaddresslabel', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  shippopautomatictracking(data, callback) {
    let url = config.serverUrl + 'webhookshippopautomatictracking'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  shippopmultiplelabelprint(data, callback) {
    let url = config.serverUrl + 'shippopmultiplelabelprint'
    axios
      .post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        },
        params: data.params
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  async geteplist(data) {
    axios.defaults.headers.common = {
      authorization: store.getters.securityToken
    }
    try {
      let res = await axios.get(config.serverUrl + 'thenextface/eplist', { params: data })
      if (res.data.responsecode == 200) {
        return res.data.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },

  async getVotingResult(data) {
    axios.defaults.headers.common = {
      authorization: store.getters.securityToken
    }
    try {
      let res = await axios.get(config.serverUrl + 'thenextface/votingresult', { params: data })
      if (res.data.responsecode == 200) {
        return res.data.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async getUserVoteByNamespace(data) {
    axios.defaults.headers.common = {
      authorization: store.getters.securityToken
    }
    try {
      let res = await axios.get(config.serverUrl + 'thenextface/getUserVoteByNamespace', {
        params: data
      })
      if (res.data.responsecode == 200) {
        return res.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async getVoteByUser(data) {
    axios.defaults.headers.common = {
      authorization: store.getters.securityToken
    }
    try {
      let res = await axios.get(config.serverUrl + 'thenextface/getVoteByUser', {
        params: data
      })
      if (res.data.responsecode == 200) {
        return res.data.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },

  async GetHippoHoldChat(data) {
    const response = await axios.get(config.serverUrl + 'hippo/chat/hold', { params: data })
    if (response.data.responsecode == 200) {
      return response.data
    } else {
      return null
    }
  },

  async SetHippoHoldChat(data) {
    const response = await axios.post(config.serverUrl + 'hippo/chat/hold', data)
    if (response.data.responsecode == 200) {
      return response.data
    } else {
      return null
    }
  },

  // Lamy
  postLamyProduct: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'lamy/cms/products', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putLamyProduct: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'lamy/cms/products', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyGiftCategory: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/gift/categories'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postLamyGiftCategory: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'lamy/cms/gift/categories', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putLamyGiftCategory: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'lamy/cms/gift/categories', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleteLamyGiftCategory: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/gift/categories'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyGiftSubCategory: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/gift/subcategories'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postLamyGiftSubCategory: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'lamy/cms/gift/subcategories', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putLamyGiftSubCategory: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'lamy/cms/gift/subcategories', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleteLamyGiftSubCategory: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/gift/subcategories'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyGiftProducts: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/gift/products'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postLamyGiftProduct: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'lamy/cms/gift/products', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putLamyGiftProduct: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'lamy/cms/gift/products', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleteLamyGiftProduct: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/gift/products'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyWarranty: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/warranty'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyWarrantyDetails: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/warranty-details'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putLamyWarrantyEdit: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'lamy/cms/warranty/edit', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyMembership: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/dashboard/membership'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyMembershipHistory: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/dashboard/membership-purchase-history'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyPdpdReport: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/dashboard/pdpa'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyPdpdReportExport: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/dashboard/pdpa/export'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyOverview2PurchaseByDate: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/overview2/purchase-bydate'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyOverview2PurchaseByTime: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/overview2/purchase-bytime'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyOverview2PurchaseByShop: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/overview2/purchase-byshop'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyOverview2PurchaseByShopDetails: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/overview2/purchase-byshop/product'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyBehaviorReportAsked: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/behavior-report/asked'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyOverview1Gender: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/overview1/gender'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyOverview1Age: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/overview1/age'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyRedeemCode: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/redeemcode/dashboard'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postLamyRedeemImport: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'lamy/cms/redeemcode/import-code', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyRedeemAllCodeById: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/redeemcode/dashboard/codes'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyGiftReport: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/giftReport'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postLamyWarrantyImport: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'lamy/cms/warrantynumber/dashboard/import', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyWarrantyImport: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/warrantynumber/dashboard'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postLamyImportProductMaster: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'lamy/cms/productmaster/import', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyProductMaster: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/productmaster'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamySaleReportTimingofPurchase: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/salesreport/timing-of-purchase'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamySaleReportBestSeller: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/salesreport/bestsellers'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamySaleReportBestColors: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/salesreport/bestcolors'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getLamyOverviewAndReport: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/overviewandreport'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  getLamyFilterProductMaster: function (data, callback) {
    let url = config.serverUrl + 'lamy/cms/filter-product-master'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  // ----- End Lamy ----- //
  // ----- Start Toa E-coupon ----- //
  getReceiptToaecoupon(data, callback) {
    let url = config.serverUrl + 'toaecoupon/receipt'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getMembersToaecoupon(data, callback) {
    let url = config.serverUrl + 'toaecoupon/members'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  updateMemberPhoneToaecoupon: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'toaecoupon/members/phone', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getMemberReceiptsToaecoupon(data, callback) {
    let url = config.serverUrl + 'toaecoupon/members/receipts'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getStoreToaecoupon(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponstore-dashboard'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  importStoreToaecoupon: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toaecoupon/ecouponstore-dashboard/import', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  insertStoreToaecoupon: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toaecoupon/ecouponstore-dashboard', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  updateStoreToaecoupon: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'toaecoupon/ecouponstore-dashboard', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleteStoreToaecoupon: function (data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponstore-dashboard'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getProductToaecoupon(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponproduct-dashboard'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  importProductToaecoupon: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toaecoupon/ecouponproduct-dashboard/import', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  insertProductToaecoupon: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'toaecoupon/ecouponproduct-dashboard', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  updateProductToaecoupon: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'toaecoupon/ecouponproduct-dashboard', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleteProductToaecoupon: function (data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponproduct-dashboard'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getUsedCouponToaecoupon(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecoupon-dashboard/used'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getAllStoreToaecoupon(data, callback) {
    let url = config.serverUrl + 'toaecoupon/stores'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getAllProductsToaecoupon(data, callback) {
    let url = config.serverUrl + 'toaecoupon/products'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  updateCouponToaecoupon: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'toaecoupon/receipt/' + data.id, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  async checkDuplicateBillToaecoupon(data) {
    // let url = config.serverUrl + 'toaecoupon/receipt/duplicate/' + data.refReceipt
    // axios.defaults.headers.common = {
    //   AUTHORIZATION: store.getters.securityToken
    // }
    // axios
    //   .get(url, {
    //     params: { storeId: data.storeId, campaignId: data.campaignId, ref_date: data.ref_date }
    //   })
    //   .then(response => {
    //     this.defaultResponse(response, callback)
    //   })
    //   .catch(e => {
    //     this.defaultError(e, callback)
    //   })

    let url = config.serverUrl + 'toaecoupon/receipt/duplicate'
    try {
      const response = await axios.post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  getTOAECOUPONReceiptById(data, callback) {
    let url = config.serverUrl + 'toaecoupon/manage/receipt/' + data.id
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: { pageid: data.pageid } })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getTOAECOUPONCampaigns(data, callback) {
    let url = config.serverUrl + 'toaecoupon/campaign'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: { pageid: data.pageid } })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONSetCampaignStatus(data, callback) {
    let url = config.serverUrl + 'toaecoupon/campaign/' + data.campaignId + '/enable'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONDeleteCampaign(data, callback) {
    let url = config.serverUrl + 'toaecoupon/campaign/' + data.campaignId
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url, { data: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONCreateCampaign(data, callback) {
    let url = config.serverUrl + 'toaecoupon/campaign'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONEditCampaign(data, callback) {
    let url = config.serverUrl + 'toaecoupon/campaign/' + data.id
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONSetRegisterBackground(data, callback) {
    let url = config.serverUrl + 'toaecoupon/background/register'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONGetRegisterBackground(data, callback) {
    let url = config.serverUrl + 'toaecoupon/background/register'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONgetEnabledCampagin(data, callback) {
    let url = config.serverUrl + 'toaecoupon/campaign/enabled'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data, headers: { 'x-api-key': 'R152HR#QpFvydvx16DIXC*A%8R6VW6w7exp' } })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONgetAllCampaign(data, callback) {
    let url = config.serverUrl + 'toaecoupon/campaign/all'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data, headers: { 'x-api-key': 'R152HR#QpFvydvx16DIXC*A%8R6VW6w7exp' } })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONCreatRewardCategory(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaign-category'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONEditRewardCategory(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaign-category'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONDeleteRewardCategory(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaign-category'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONGetRewardCategoryByCategoryId(data, callback) {
    let url = config.serverUrl + 'toaecoupon/reward/category/campaign/' + data.campaignId
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONGetRewardProduct(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaign-product'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONCreateRewardProduct(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaign-product'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONEditRewardProduct(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaign-product'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONDeleteRewardProduct(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaign-product'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  EXPORT_TOAECOUPONGetRewardRequest(data, callback) {
    let url = config.serverUrl + 'toaecoupon/exportrewards'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONGetRewardRequest(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaignrewards'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONApproveAllRewardRequest(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaignrewards/approved-all-rewards'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONApproveRewardRequest(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaignrewards/approved-rewards'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  TOAECOUPONGetShippingReward(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaignrewards/shipping'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONUpdateShippingRewardStatus(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaignrewards/shipping/update-status'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONUpdateShippingRewardInfo(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaignrewards/shipping/update-info'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONSendingTrackingForReward(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaignrewards/shipping/send-tracking'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONUpdateShippingReward(data, callback) {
    let url = config.serverUrl + 'toaecoupon/ecouponcampaignrewards/shipping/update-info'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONSendEcouponByRewardOrder(data, callback) {
    let url = config.serverUrl + 'toaecoupon/reward/order/ecoupon'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONDeleteAllProducts(data, callback) {
    let url = config.serverUrl + 'toaecoupon/products'
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONDeleteAllStores(data, callback) {
    let url = config.serverUrl + 'toaecoupon/stores'
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TOAECOUPONUpdateAddressByRewardOrder(data, callback) {
    let url = config.serverUrl + 'toaecoupon/reward/order/address'
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  // TD Tawandang
  TDgetLiveChatUsers: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'tdtawandang/cms/usersthread'
    axios
      .post(url, data.body, { params: data.params })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TDsetWorkingHours: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'common/setWorkingHours'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TDsetAnswerAfterHours: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'common/setAnswerAfterHours'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TDgetticket: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'tdtawandang/cms/tickets', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TDCreateTicket: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'commonnewticket/cms/createTicketByAdmin', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TDUpdateTicket: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'commonnewticket/cms/tickets', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TDticketbyagent: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'commonnewticket/cms/ticketsByAgent', { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TDTransferTicket: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'commonnewticket/cms/transferTicket', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TDGetTicketsByStatus: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'commonnewticket/cms/ticketsByStatus'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TDGetTicketsCloseCase: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    let url = config.serverUrl + 'commonnewticket/cms/ticketsCloseCase'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  TDGetTicketsCloseCaseDetailByAdmin: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    let url = config.serverUrl + 'commonnewticket/cms/ticketsCloseCaseDetailByAdmin'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  // Next capital
  async NextCapitalCloseTicket(data) {
    axios.defaults.headers.common = {
      authorization: store.getters.securityToken
    }
    try {
      let res = await axios.post(
        config.serverUrl + 'nextcapital/closeTicketUpdateData/' + data.ticketId,
        data
      )
      if (res.data.responsecode == 200) {
        return true
      } else {
        return false
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },

  async updateOpenWorkingHours(data) {
    axios.defaults.headers.common = {
      authorization: store.getters.securityToken
    }
    try {
      const response = await axios.post(`${config.serverUrl}common/setOpenWorkingHours`, data)
      if (response.data.responsecode == 200) {
        return true
      } else {
        return false
      }
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async getUserTagList(data = { limit: 25, offset: 0, filter_name: undefined, sort: 'name_asc' }) {
    let url = `${config.serverUrl}page/${store.state.selectedBot.pageid}/user-tag-list`
    try {
      var response = await axios.get(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed',
          AUTHORIZATION: store.getters.securityToken
        },
        params: data
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async deleteUserTagList(data) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + `page/` + store.state.selectedBot.pageid + `/user-tag-list`
    try {
      var response = await axios.delete(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        },
        data: data.body
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async deleteUserStatusList(data) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + `page/` + store.state.selectedBot.pageid + `/user-status-list`
    try {
      var response = await axios.delete(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        },
        data: data.body
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async getUserStatusList(
    data = { limit: 25, offset: 0, filter_name: undefined, sort: 'name_asc' }
  ) {
    let url = `${config.serverUrl}page/${store.state.selectedBot.pageid}/user-status-list`
    try {
      var response = await axios.get(url, {
        headers: {
          'api-key': '1-2-3-sharks-landed',
          AUTHORIZATION: store.getters.securityToken
        },
        params: data
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  async getFollowupMessage(data) {
    let url = config.serverUrl + `followMessage/${data.pageid}`

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      const response = await axios.get(url, data)
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async postFollowMessage(data) {
    let url = config.serverUrl + `followMessage/${data.pageid}`

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      const response = await axios.post(url, data.data, { params: data.params })
      return await this.defaultResponse2(response)
    } catch (error) {
      return this.defaultError2(error)
    }
  },
  async putFollowMessage(data) {
    let url = config.serverUrl + `followMessage/${data.pageid}`

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      const response = await axios.put(url, data.data, { params: data.params })
      return await this.defaultResponse2(response)
    } catch (error) {
      return this.defaultError2(error)
    }
  },
  async deleteFollowupMessage(data) {
    let url = config.serverUrl + `followMessage/${data.pageid}/${data.id}`

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      const response = await axios.delete(url)
      return await this.defaultResponse2(response)
    } catch (error) {
      return this.defaultError2(error)
    }
  },
  // async getFollowupMessageReport(data) {
  //   let url = config.serverUrl + `followMessageReport/${data.pageid}`

  //   axios.defaults.headers.common = {
  //     AUTHORIZATION: store.getters.securityToken
  //   }
  //   try {
  //     let response = await axios.get(url, data)
  //     return this.defaultResponse2(response, null)
  //   } catch (error) {
  //     return this.defaultError2(error, null)
  //   }
  // },
  async getFollowupMessageReport(data) {
    let url = config.serverUrl + `getFollowMessagesReportNew/${data.pageid}`

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let response = await axios.get(url, data)
      return this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async getFollowMessageCampaigns(data) {
    let url = config.serverUrl + `followMessageCampaigns/${data.pageid}`

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let response = await axios.get(url, data)
      return this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async getFollowupMessageReportAvailableCodes(data) {
    let url =
      config.serverUrl +
      `getFollowMessagesReportNewAvailableCodes/${data.pageid}/${data.campaign_id}`

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let response = await axios.get(url, data)
      return this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async getFollowMessagesReportNewUsedCodes(data) {
    let url =
      config.serverUrl + `getFollowMessagesReportNewUsedCodes/${data.pageid}/${data.campaign_id}`

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let response = await axios.get(url, data)
      return this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },

  putpriorityproductskfc: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `kfc/cms/priority-products?pageid=${data.pageid}`, {
        productslist: data.input
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  async getTopCustomer(data) {
    let url = config.serverUrl + `toaecoupon/topcustomer`

    try {
      const response = await axios.get(url, {
        params: data,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async getTopStore(data) {
    let url = config.serverUrl + `toaecoupon/topstore`

    try {
      const response = await axios.get(url, {
        params: data,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },

  async getReceiptHistory(data) {
    let url = config.serverUrl + `toaecoupon/topcustomer/${data.userid}`

    try {
      const response = await axios.get(url, {
        params: data,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async getStoreHistory(data) {
    let url = config.serverUrl + `toaecoupon/topstore/${data.store_id}`

    try {
      const response = await axios.get(url, {
        params: data,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async clearPrivilege(data) {
    let url = config.serverUrl + `toaecoupon/clearprivilege`

    try {
      const response = await axios.post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async getToaCustomer(data) {
    let url = config.serverUrl + `toaecoupon/customers`

    try {
      const response = await axios.get(url, {
        params: data,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },

  async findAnnounceLuckydraw(data) {
    let url = config.serverUrl + `toaecoupon/announceluckydraw`

    try {
      const response = await axios.get(url, {
        params: data,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async getAnnounceLuckydrawHistory(data) {
    let url = config.serverUrl + `toaecoupon/announceluckydraw/history`

    try {
      const response = await axios.get(url, {
        params: data,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },

  async saveAnnouceLuckydraw(data) {
    let url = config.serverUrl + `toaecoupon/announceluckydraw`

    try {
      const response = await axios.post(url, data.body, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },

  // Plern
  postPlernVoucherDashboard: function (data, callback) {
    let url = config.serverUrl + 'plern/getIntentWithCode'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postPlernGetCode: function (data, callback) {
    let url = config.serverUrl + 'plern/getCode'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postPlernUpdateStatus: function (data, callback) {
    let url = config.serverUrl + 'plern/openCloseCode'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getPlernVoucherCommentIntentName: function (data, callback) {
    let url = config.serverUrl + 'plern/getVoucherCommentIntentName'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postPlernImportCode: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'plern/importCode', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postPlernDeleteCode: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    axios
      .post(config.serverUrl + 'plern/deleteCode', data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postPlernImportCurrentGroup: function (data, callback) {
    let url = config.serverUrl + 'plern/importCodeCurrentGroup'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticketCountStatus: async function (pageid) {
    const url = `${config.serverUrlticket}ticket/countStatus/${pageid}`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    try {
      let res = await axios.get(url)
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  getSatisScore: function (data, callback) {
    axios.defaults.headers.common = {
      authorization: store.getters.securityToken
    }
    const url = `${config.serverUrl}cotto/getComplacence`
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postGPKlocationImport: function (data, callback) {
    let url = config.serverUrl + 'gpklocation/import'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postGPKlocation: function (data, callback) {
    let url = config.serverUrl + 'gpklocation'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putGPKlocation: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `gpklocation`, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleteGPKlocation: function (data, callback) {
    let url = config.serverUrl + 'gpklocation'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  async exportFollowMessagesReport(data) {
    let url = config.serverUrl + `exportFollowMessagesReport/${data.pageid}/${data.campaignid}`

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    try {
      let response = await axios.get(url, data)
      return this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  getCategoriesThailandPostmart: function (data, callback) {
    let url = `${config.serverUrl}tero/shop/category`
    axios.defaults.headers.common = {
      'x-api-key': '7@cuTnLXX1TK78mHOJF#wI$NkkyG8A'
    }
    axios
      .get(url, { params: { pageid: data.pageid } })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postuploadproducts: function (data, callback) {
    axios.defaults.headers.common = {
      authorization: store.getters.securityToken
    }
    let url = config.serverUrl + 'uploadzwizproducts'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticketCountStatusWithCondition: async function (data) {
    let url = config.serverUrl + 'ticket/countTicketStatusWithCondition'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    try {
      let res = await axios.get(url, { params: data })
      if (res.data.responsecode == 200) {
        return res.data.data
      }
    } catch (error) {
      console.error(error)
    }
  },
  getRabbitUserThreadWithPost: function (data, callback) {
    axios.defaults.headers.common = {
      authorization: store.getters.securityToken
    }
    let url = config.serverUrl + 'rabbit/cms/getUserThreadWithPost'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getRabbitChatlogWithPost: function (data, callback) {
    axios.defaults.headers.common = {
      authorization: store.getters.securityToken
    }
    let url = config.serverUrl + 'rabbit/cms/getUserChatLogWithPost'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postRabbitSendMessage: function (data, callback) {
    axios.defaults.headers.common = {
      authorization: store.getters.securityToken
    }
    let url = config.serverUrl + 'rabbit/cms/rabbitSendMessage'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postRabbitUpdateTicket: function (data, callback) {
    axios.defaults.headers.common = {
      authorization: store.getters.securityToken
    }
    let url = config.serverUrl + 'rabbit/updateticketstatus'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postRabbitAdminReadChat: function (data, callback) {
    axios.defaults.headers.common = {
      authorization: store.getters.securityToken
    }
    let url = config.serverUrl + 'rabbit/adminreadchat'
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getProductBySlugThailandPostmart: function (data, callback) {
    let url = `${config.serverUrl}tero/shop/category/${data.slug}`
    axios.defaults.headers.common = {
      'x-api-key': '7@cuTnLXX1TK78mHOJF#wI$NkkyG8A'
    }
    axios
      .get(url, {
        params: {
          pageid: data.pageid,
          pages: data.pages,
          per_page: data.per_page,
          search: data.search
        }
      })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  async postUserTagListByUserId(data) {
    try {
      const response = await axios.post(
        `${config.serverUrl}analyticDashboard/getUserTagListByUserId`,
        data,
        {
          headers: {
            AUTHORIZATION: store.getters.securityToken
          }
        }
      )
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async updatePageConfig(data) {
    try {
      const response = await axios.put(
        `${config.serverUrl}page/${data.pageid}/update-page-config`,
        data.body,
        {
          headers: {
            'api-key': '1-2-3-sharks-landed',
            AUTHORIZATION: store.getters.securityToken
          }
        }
      )
      return await this.defaultResponse2(response)
    } catch (error) {
      return this.defaultError2(error)
    }
  },
  async getCustomAudience(data) {
    try {
      const response = await axios.get(
        `${config.serverUrl}page/${data.pageid}/facebook-ad/custom-audience`,
        {
          headers: {
            'api-key': '1-2-3-sharks-landed',
            AUTHORIZATION: store.getters.securityToken
          }
        }
      )
      return await this.defaultResponse2(response)
    } catch (error) {
      return this.defaultError2(error)
    }
  },
  async deleteCustomAudience(data) {
    try {
      const response = await axios.delete(
        `${config.serverUrl}page/${data.pageid}/facebook-ad/custom-audience/${data.id}`,
        {
          headers: {
            'api-key': '1-2-3-sharks-landed',
            AUTHORIZATION: store.getters.securityToken
          }
        }
      )
      return await this.defaultResponse2(response)
    } catch (error) {
      return this.defaultError2(error)
    }
  },
  async reportMessageBeaconsList(data) {
    try {
      const response = await axios.get(
        `${config.serverUrl}line-beacon/${data.pageid}/report-message`,
        { params: data.params },
        {
          headers: {
            'api-key': '1-2-3-sharks-landed',
            AUTHORIZATION: store.getters.securityToken
          }
        }
      )
      return await this.defaultResponse2(response)
    } catch (error) {
      return this.defaultError2(error)
    }
  },

  async reportUserByDateBeaconsList(data) {
    try {
      var response = await axios.get(
        `${config.serverUrl}line-beacon/${data.pageid}/report-user-by-date`,
        { params: data.params },
        {
          headers: {
            'api-key': '1-2-3-sharks-landed',
            AUTHORIZATION: store.getters.securityToken
          }
        }
      )
      return await this.defaultResponse2(response)
    } catch (error) {
      return this.defaultError2(error)
    }
  },

  async reportUserByTimeBeaconsList(data) {
    try {
      var response = await axios.get(
        `${config.serverUrl}line-beacon/${data.pageid}/report-user-by-time`,
        { params: data.params },
        {
          headers: {
            'api-key': '1-2-3-sharks-landed',
            AUTHORIZATION: store.getters.securityToken
          }
        }
      )
      return await this.defaultResponse2(response)
    } catch (error) {
      return this.defaultError2(error)
    }
  },

  async createCustomAudience(data) {
    try {
      var response = await axios.post(
        `${config.serverUrl}page/${data.pageid}/facebook-ad/custom-audience`,
        data.body,
        {
          headers: {
            'api-key': '1-2-3-sharks-landed',
            AUTHORIZATION: store.getters.securityToken
          }
        }
      )
      return await this.defaultResponse2(response)
    } catch (error) {
      if (error.response.data && error.response.data.result && error.response.data.result.error) {
        throw new Error(
          error.response.data.result.error.error_user_title ||
            error.response.data.result.error.message ||
            'Something went wrong'
        )
      } else {
        return await this.defaultError2(error)
      }
    }
  },
  async getInstagramDetail() {
    try {
      var response = await axios.get(`https://graph.facebook.com/v12.0/me`, {
        params: {
          fields: 'id,name,instagram_business_account.fields(id,name,username,profile_picture_url)',
          access_token: store.state.selectedBot.page_access_token
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      return this.defaultError2(error)
    }
  },
  async liveChatUserOrders(data) {
    try {
      var response = await axios.get(`${config.serverUrl}livechat/user-orders`, {
        params: data,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async liveChatUserCart(data) {
    try {
      var response = await axios.get(`${config.serverUrl}livechat/user-cart`, {
        params: data,
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },

  ticket2CommonGetTicket: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}commonnewticket/cms/tickets`
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonGetTicket2: async function (data, callback) {
    try {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      const url = `${config.serverUrl}commonnewticket/cms/tickets`
      const responseData = await axios.get(url, { params: data })
      return responseData
    } catch (error) {
      throw error
    }
  },
  ticket2CommonCreateTicket: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}commonnewticket/cms/createTicketByAdmin`
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonTransferTicket: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}commonnewticket/cms/transferTicket`
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonUpdateTicket: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}commonnewticket/cms/tickets`
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonGetTicketsByStatus: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}commonnewticket/cms/ticketsByStatus`
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonGetTicketsCloseCase: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}commonnewticket/cms/ticketsCloseCase`
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonGetTicketsCloseCaseDetailByAdmin: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}commonnewticket/cms/ticketsCloseCaseDetailByAdmin`
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonGetTicketsCloseCaseDetailByAdminWithSubject: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}commonnewticket/cms/userTicketsCloseCaseDetailByAdminWithSubject`
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonExportTicketsByStatus: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}commonnewticket/cms/exportTicketsByStatus`
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2Commonticketworklog: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}commonnewticket/cms/worklog`
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonReadWorklog: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}commonnewticket/cms/read-worklog`
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonTicketByAgent: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}commonnewticket/cms/ticketsByAgent`
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonTicketByAgentWithWorkingHour: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}commonnewticket/cms/ticketsByAgentWithWorkingHour`
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonSetWorkingHours: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}common/setWorkingHours`
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonSetAnswerAfterHours: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}common/setAnswerAfterHours`
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonCheckinCheckoutLog: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `${config.serverUrl}commonnewticket/cms/checkInCheckOutLogByAdminId`
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  ticket2CommonCheckinCheckout(data, callback) {
    let url = `${config.serverUrl}commonnewticket/cms/checkInCheckOut`
    axios
      .post(url, data)
      .then((response) => {
        if (response.status == 200) callback(null, response.data)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getGroupConversationByPageId: function (data, callback) {
    axios.defaults.headers.common = {
      authorization: store.getters.securityToken
    }
    const url = `${config.serverUrl}intents/getGroupConversationByPageId?pageid=${data.pageid}`
    axios
      .get(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  postGroupConversation: function (data, callback) {
    const url = `${config.serverUrl}intents/createGroupConversation`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getSecapMaintenanceReservation: function (data, callback) {
    const url = `${config.serverUrl}secap/maintenance-reservation/dashboard`
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  getSecapMaintenanceStores: function (data, callback) {
    const url = `${config.serverUrl}secap/maintenance-reservation/stores`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  importSecapMaintenanceStores: function (data, callback) {
    const url = `${config.serverUrl}secap/maintenance-reservation/import-stores`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  addSecapMaintenanceStores: function (data, callback) {
    const url = `${config.serverUrl}secap/maintenance-reservation/add-store`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  updateSecapMaintenanceStores: function (data, callback) {
    const url = `${config.serverUrl}secap/maintenance-reservation/update-store`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  deleteSecapMaintenanceStores: function (data, callback) {
    const url = `${config.serverUrl}secap/maintenance-reservation/delete-store?pageid=${data.pageid}&id=${data.id}`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  updateSecapRemark: function (data, callback) {
    const url = `${config.serverUrl}secap/maintenance-reservation/note-remark`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putGroupConversation: function (data, callback) {
    const url = `${config.serverUrl}intents/updateNameGroupConversationById`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  deleteGroupConversation: function (data, callback) {
    const url = `${config.serverUrl}intents/deleteGroupConversationById`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url, { params: data })
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },

  putStatusGroupConversation: function (data, callback) {
    const url = `${config.serverUrl}intents/updateStatusGroupConversationById`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  putPriorityGroupConversation: function (data, callback) {
    const url = `${config.serverUrl}intents/updatePriorityGroupConversationByPageId`
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  toaPaintGetConversationDetails: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    const url = `${config.serverUrl}analyticDashboard/getConversationDetails/${data.pageid}`
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  toaPaintGetConversationDetailsWithQuestionData: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    const url = `${config.serverUrl}analyticDashboard/getUsersConversationDetailsWithQuestionData/${data.pageid}`
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  toaPaintExportConversationDetails: function (data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    const url = `${config.serverUrl}analyticDashboard/exportsUsersConversationDetails/${data.pageid}`
    axios
      .post(url, data)
      .then((response) => {
        this.defaultResponse(response, callback)
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  async getGiveawayProduct(data) {
    try {
      const response = await axios.post(`${config.serverUrl}giveaway-product/products`, data, {
        headers: {
          'api-key': '1-2-3-sharks-landed'
        }
      })
      return await this.defaultResponse2(response)
    } catch (error) {
      this.defaultError2(error)
    }
  },
  async gpfGetAnswerReport(data) {
    try {
      const response = await axios.post(
        `${config.serverUrl}government-pension-fund/answers-tags-report/dashboard`,
        data,
        {
          headers: {
            AUTHORIZATION: store.getters.securityToken
          }
        }
      )
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async cityfreshGetPromotionCode(data) {
    try {
      const response = await axios.get(`${config.serverUrl}city-fresh/promotion-code-report`, {
        params: data,
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async gpfGetSatisfactionScores(data) {
    try {
      const response = await axios.get(
        `${config.serverUrl}government-pension-fund/tickets/satisfaction-scores`,
        {
          params: data,
          headers: {
            AUTHORIZATION: store.getters.securityToken
          }
        }
      )
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async ticket2GetTicketHistory(data) {
    try {
      const response = await axios.get(
        `${config.serverUrl}commonnewticket/${data.pageId}/cms/ticket-history/${data.ticketId}`,
        {
          headers: {
            AUTHORIZATION: store.getters.securityToken
          }
        }
      )
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async ticket2GetCountTicket(data) {
    try {
      const response = await axios.get(
        `${config.serverUrl}commonnewticket/cms/ticket-card-counts`,
        {
          params: data,
          headers: {
            AUTHORIZATION: store.getters.securityToken
          }
        }
      )
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async getStatusColor(pageId) {
    try {
      const response = await axios.get(`${config.serverUrl}bbq/status-color/${pageId}`, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async addStatusColor(data) {
    try {
      const response = await axios.post(`${config.serverUrl}bbq/status-color`, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async updateStatusColor(data) {
    try {
      const response = await axios.patch(`${config.serverUrl}bbq/status-color/${data.id}`, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async deleteStatusColor(data) {
    try {
      const response = await axios.delete(`${config.serverUrl}bbq/status-color/${data.id}`, data, {
        headers: {
          AUTHORIZATION: store.getters.securityToken
        }
      })
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },
  async ticketCloseMultiTicket(data, pageId) {
    try {
      const response = await axios.put(
        `${config.serverUrl}commonnewticket/cms/close-multi-tickets`,
        data,
        {
          params: {
            page_id: pageId
          },
          headers: {
            AUTHORIZATION: store.getters.securityToken
          }
        }
      )
      return await this.defaultResponse2(response, null)
    } catch (error) {
      return this.defaultError2(error, null)
    }
  },

  // end
  // =============== default function =================

  async defaultResponse2(response, options = null) {
    var { data } = response
    let isForceLogout = true
    if (options && Object.hasOwnProperty.call(options, 'isForceLogout'))
      isForceLogout = options.isForceLogout
    if (data.responsecode && data.responsecode == 400) {
      if (isForceLogout) await this.forceLogout(response, '')

      let error = new Error(
        (response.status ? response.status + ': ' : '') +
          (data.reason || 'Session expire. Please login again.')
      )

      error.response = response
      throw error
    } else if (response.status == 200) {
      return data
    }
  },

  defaultError2(error) {
    // eslint-disable-next-line no-undef
    if (process.env.NODE_ENV !== 'production') {
      if (error) console.error(error)
    }
    throw error
    // throw new Error('Session expire. Please login again.')
  },

  defaultResponse: function (response, callback, forceLogout = true) {
    let url = response.config.url
    response = response.data

    if (response.responsecode === 200) {
      if (callback) callback(null, response)
      else return response
    } else if (response.responsecode === 400 && response.closed_ticket === false) {
      if (callback) callback(null, response)
    } else if (response.responsecode === 400) {
      let message = response.reason ? response.reason : ''
      console.error(
        `[Error] ${url || '-'} (${response.responsecode}) -> ${message || 'No message'}`
      )

      if (forceLogout) {
        // console.log('before',isFacebook)
        this.forceLogout(response).then(() => {
          if (callback) callback(new Error('Session expire. Please login again.'))
          else throw new Error('Session expire. Please login again.')
        })
      } else {
        if (callback) callback(new Error('Session expire. Please login again.'))
        else throw new Error('Session expire. Please login again.')
      }
    } else {
      console.error(
        `[Error] ${url || '-'} (${response.responsecode}) -> ${
          response.reason || response.message || 'No message'
        }`
      )
      Vue.swal.fire({ text: response.reason || response.message })
      if (response.reason) {
        if (callback) callback(new Error(response.reason))
        else throw new Error(response.reason)
      } else {
        if (callback) callback()
        else throw new Error('Something went wrong')
      }
    }
  },

  defaultError: function (e, callback) {
    // eslint-disable-next-line no-undef
    if (process.env.NODE_ENV !== 'production') {
      console.log(e)
    }
    if (callback) callback(new Error('Session expire. Please login again.'))
    else {
      throw new Error('Session expire. Please login again.')
    }
  },

  joinFilter: function (data, isPremium) {
    var url = []
    if (data['gender']) {
      url.push('gender=' + data['gender'].value)
    }
    if (data['fullname']) {
      url.push('fullname=' + data['fullname'])
    }
    if (data['app']) {
      if (data['app'].value !== 'all') {
        url.push('app=' + data['app'].value)
      }
    }
    if (data['locale'] && data['locale'].length > 0) {
      var locales = []
      if (data['locale']) {
        data['locale'].map(function (locale) {
          locales.push(locale.value)
        })
      }
      url.push('locale=' + locales.join(','))
    }
    if (data['tagtype']) {
      url.push('tagtype=' + data['tagtype'])
    }
    if (data['tags']) {
      url.push('tags=' + data['tags'])
    }
    if (data['statustype']) {
      url.push('statustype=' + data['statustype'])
    }
    if (data['activeDate']['start']) {
      url.push('timestamp_from=' + moment(data['activeDate']['start']).format('YYYY-MM-DD'))
    }
    if (data['activeDate'] && data['activeDate']['end']) {
      url.push('timestamp_to=' + moment(data['activeDate']['end']).format('YYYY-MM-DD'))
    }
    if (data['registerDate'] && data['registerDate']['start']) {
      url.push(
        'registertimestamp_from=' + moment(data['registerDate']['start']).format('YYYY-MM-DD')
      )
    }
    if (data['registerDate'] && data['registerDate']['end']) {
      url.push('registertimestamp_to=' + moment(data['registerDate']['end']).format('YYYY-MM-DD'))
    }
    if (data['lineid']) {
      url.push('lineid=' + data['lineid'])
    }
    if (data['school']) {
      url.push('school=' + data['school'].name)
    }
    if (data['realname']) {
      url.push('realname=' + data['realname'])
    }
    if (data['province']) {
      url.push('province=' + data['province'])
    }
    if (data['subdistrict']) {
      url.push('subdistrict=' + data['subdistrict'])
    }
    if (data['district']) {
      url.push('district=' + data['district'])
    }
    if (data['postcode']) {
      url.push('postcode=' + data['postcode'])
    }
    if (data['uu_register_status']) {
      url.push('uu_register_status=' + data['uu_register_status'])
    }
    if (data['uu_name']) {
      url.push('uu_name=' + data['uu_name'])
    }
    if (data['uu_dma']) {
      url.push('uu_dma=' + data['uu_dma'])
    }
    if (data['uu_areaname']) {
      url.push('uu_areaname=' + data['uu_areaname'])
    }

    if (data['specialcondition']) {
      url.push('specialcondition=' + data['specialcondition'].value)
    }

    if (data['lamy_member_type']) {
      const tempData = data['lamy_member_type']
      const val = tempData.map((el) => {
        return el.value
      })
      url.push('lamy_member_type=' + val.toString())
    }
    if (data['lamy_interested_product_type']) {
      url.push('lamy_interested_product_type=' + data['lamy_interested_product_type'])
    }
    if (data['lamy_total_purchase_from']) {
      url.push('lamy_total_purchase_from=' + data['lamy_total_purchase_from'])
    }
    if (data['lamy_total_purchase_to']) {
      url.push('lamy_total_purchase_to=' + data['lamy_total_purchase_to'])
    }
    if (data['lamy_total_product_purchase_from']) {
      url.push('lamy_total_product_purchase_from=' + data['lamy_total_product_purchase_from'])
    }
    if (data['lamy_total_product_purchase_to']) {
      url.push('lamy_total_product_purchase_to=' + data['lamy_total_product_purchase_to'])
    }
    if (data['lamy_product_category'] && data['lamy_product_category'].length > 0) {
      const val = data['lamy_product_category'].toString()
      url.push('lamy_product_category=' + val)
    }
    if (data['lamy_product_model'] && data['lamy_product_model'].length > 0) {
      const val = data['lamy_product_model'].toString()
      url.push('lamy_product_model=' + val)
    }
    if (data['lamy_product_name'] && data['lamy_product_name'].length > 0) {
      const val = data['lamy_product_name'].toString()
      url.push('lamy_product_name=' + val)
    }
    if (data['lamy_product_size'] && data['lamy_product_size'].length > 0) {
      const val = data['lamy_product_size'].toString()
      url.push('lamy_product_size=' + val)
    }
    if (data['lamy_product_head_type'] && data['lamy_product_head_type'].length > 0) {
      const val = data['lamy_product_head_type'].toString()
      url.push('lamy_product_head_type=' + val)
    }
    if (data['lamy_product_colour'] && data['lamy_product_colour'].length > 0) {
      const val = data['lamy_product_colour'].toString()
      url.push('lamy_product_colour=' + val)
    }

    if (data['toa_member_tier']) {
      url.push('toa_member_tier=' + data['toa_member_tier'])
    }
    if (data['juzmatch_member_role'] && data['juzmatch_member_role'].value) {
      url.push('juzmatch_member_role=' + data['juzmatch_member_role'].value)
    }

    if (data['tcp_member_level_id']) {
      url.push('tcp_member_level_id=' + data['tcp_member_level_id'])
    }

    if (data['tcp_pdpa']) {
      url.push('tcp_pdpa=' + data['tcp_pdpa'])
    }

    if (data['member_status']) {
      url.push('member_status=' + data['member_status'])
    }
    if (data['gpf_company_code'] && data['gpf_company_code'].company_code !== 'All') {
      url.push('gpf_company_code=' + data['gpf_company_code'].company_code)
    }
    if (data['gpf_group_code'] && data['gpf_group_code'].group_code !== 'All') {
      url.push('gpf_group_code=' + data['gpf_group_code'].group_code)
    }
    if (data['gpf_department_code'] && data['gpf_department_code'].department_code !== 'All') {
      url.push('gpf_department_code=' + data['gpf_department_code'].department_code)
    }
    if (data['gpf_position_code'] && data['gpf_position_code'].position_code !== 'All') {
      url.push('gpf_position_code=' + data['gpf_position_code'].position_code)
    }

    if (isPremium) {
      if (data['email']) {
        url.push('email=' + data['email'])
      }
      if (data['context']) {
        url.push('context=' + data['context'])
      }
      if (data['phoneno']) {
        url.push('phoneno=' + data['phoneno'])
      }
      if (data['status'] && data['status'].length > 0) {
        url.push('status=' + data['status'])
      }
      if (data['intent'] && data['intent'].length > 0) {
        url.push('intent=' + data['intent'].join(','))
      }
      if (data['timezone'] && (data['timezone']['from'] || data['timezone']['to'])) {
        var timezone = []
        if (data['timezone']['from']) {
          timezone.push(data['timezone']['from'])
        }
        if (data['timezone']['to']) {
          timezone.push(data['timezone']['to'])
        }
        url.push('timezone=' + timezone.join(','))
      }
    }

    return url.join('&')
  },
  joinFilterToObject: function (data, isPremium) {
    var filter = {}
    if (data['gender']) {
      Object.assign(filter, { gender: data['gender'].value })
    }
    if (data['fullname']) {
      Object.assign(filter, { fullname: data['fullname'] })
    }
    if (data['app']) {
      if (data['app'].value !== 'all') {
        Object.assign(filter, { app: data['app'].value })
      }
    }
    if (data['locale'] && data['locale'].length > 0) {
      var locales = []
      if (data['locale']) {
        data['locale'].map(function (locale) {
          locales.push(locale.value)
        })
      }
      Object.assign(filter, { locale: locales.join(',') })
    }
    if (data['tags']) {
      if (data['tagtype'] == 'excludes') {
        let tags = data['tags'].split(',')
        let newTags = ''
        tags.forEach(function (el, i) {
          if (i > 0) {
            newTags += '&&!(' + el + ')'
          } else {
            newTags += '!(' + el + ')'
          }
        })
        Object.assign(filter, { tags: newTags })
      } else {
        Object.assign(filter, { tags: data['tags'] })
      }
    }
    if (data['activeDate'] && data['activeDate']['start']) {
      Object.assign(filter, {
        timestamp_from: moment(data['activeDate']['start']).format('YYYY-MM-DD')
      })
    }
    if (data['activeDate'] && data['activeDate']['end']) {
      Object.assign(filter, {
        timestamp_to: moment(data['activeDate']['end']).format('YYYY-MM-DD')
      })
    }
    if (data['registerDate'] && data['registerDate']['start']) {
      Object.assign(filter, {
        registertimestamp_from: moment(data['registerDate']['start']).format('YYYY-MM-DD')
      })
    }
    if (data['registerDate'] && data['registerDate']['end']) {
      Object.assign(filter, {
        registertimestamp_to: moment(data['registerDate']['end']).format('YYYY-MM-DD')
      })
    }
    if (data['lineid']) {
      Object.assign(filter, { lineid: data['lineid'] })
    }
    if (data['school']) {
      Object.assign(filter, { school: data['school'].name })
    }
    if (data['province']) {
      Object.assign(filter, { province: data['province'] })
    }

    if (data['realname']) {
      Object.assign(filter, { realname: data['realname'] })
    }

    if (data['uu_register_status']) {
      Object.assign(filter, { uu_register_status: data['uu_register_status'] })
    }
    if (data['uu_name']) {
      Object.assign(filter, { uu_name: data['uu_name'] })
    }
    if (data['uu_dma']) {
      Object.assign(filter, { uu_dma: data['uu_dma'] })
    }
    if (data['uu_areaname']) {
      Object.assign(filter, { uu_areaname: data['uu_areaname'] })
    }

    if (data['specialcondition']) {
      Object.assign(filter, { specialcondition: data['specialcondition'].value })
    }

    if (isPremium) {
      if (data['email']) {
        Object.assign(filter, { email: data['email'] })
      }
      if (data['context']) {
        Object.assign(filter, { context: data['context'] })
      }
      if (data['phoneno']) {
        Object.assign(filter, { phoneno: data['phoneno'] })
      }
      if (data['status'] && data['status'].length > 0) {
        Object.assign(filter, { status: data['status'] })
      }
      if (data['intent'] && data['intent'].length > 0) {
        Object.assign(filter, { intent: data['intent'].join(',') })
      }
      if (data['timezone'] && (data['timezone']['from'] || data['timezone']['to'])) {
        var timezone = []
        if (data['timezone']['from']) {
          timezone.push(data['timezone']['from'])
        }
        if (data['timezone']['to']) {
          timezone.push(data['timezone']['to'])
        }
        Object.assign(filter, { timezone: timezone.join(',') })
      }
    }
    return filter
  },
  async forceLogout(response, message) {
    let reason = message || response.reason || 'Session expire. Please login again.'
    await store.dispatch('logout', {
      code: response.responsecode,
      message: reason
    })

    if (router.history.current.name !== 'login' || router.history.current.name !== 'nigol') {
      router.push({
        path: `/${store.getters.currentLang}/nigol`,
        query: {
          ...router.query,
          redirect: router.currentRoute.fullPath
        }
      })
    }

    return reason
  },

  async exportChatLog(data) {
    const { pageId, startDate, endDate } = data
    try {
      const response = await axios.post(
        `${config.serverUrl}common/export-chatlog/${pageId}`,
        {
          startDate,
          endDate
        },
        {
          responseType: 'blob'
        }
      )

      return response
    } catch (error) {
      return this.defaultError2(error)
    }
  },
  get_fb_broadcast_errors(data, callback) {
    let url = config.serverUrl + 'get_fb_broadcast_errors'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(
          { ...response, data: { ...response.data, responsecode: response.status } },
          callback
        )
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  },
  get_line_broadcast_errors(data, callback) {
    let url = config.serverUrl + 'get_line_broadcast_errors'
    axios
      .get(url, { params: data })
      .then((response) => {
        this.defaultResponse(
          { ...response, data: { ...response.data, responsecode: response.status } },
          callback
        )
      })
      .catch((e) => {
        this.defaultError(e, callback)
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js